import React, { useEffect, useState } from "react";
import "./PersonalInfo.scss";
import InputField from "../../UI/InputField/InputField";
import Tag from "../../UI/Tag/Tag";
import DropdownSearch from "../../UI/DropdownSearch/DropdownSearch";
import Button, {
  DashedButton,
  TransparentButton,
} from "../../UI/Button/Button";
import SubmitButton from "../../UI/Button/Button";
import Toggle from "../../UI/Toggle/Toggle";
import GlobalStore from "../../store/globalStore";
import Backdrop from "../../UI/Backdrop/Backdrop";
import micr from "../../../assets/icons/micr.jpg";
import { AGetKycDetails } from "../../Services/dashboard/profileApiService";
import { IListObj, ITokenObj } from "../../types/genericTypes";
import ErrMsg from "../../UI/ErrMsg/ErrMsg";
import moment from "moment";

import {
  aadhaarDocumnetId,
  addressType,
  corrAadhaarDocumnetId,
  corrDlDocumentId,
  corrPassportDocumnetId,
  corrVoterIdDocumentId,
  dashboardUrl,
  DIY,
  dlDocumentId,
  panDocumentId,
  passportDocumnetId,
  voterIdDocumentId,
} from "../../utils/constants";
// import { useHistory } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import gtmService from "../../Services/gtmService";
import mixpanelService from "../../Services/mixpanelService";
import mixpanelEvents, { getScreenName } from "../../../config/mixpanelEvents";
import cleverTapEvents from "../../../config/cleverTapEvents";
import { ClevertapService } from "../../Services/clevertapService";
import { AppsFlyerService } from "../../Services/appsFlyerService";
import appsFlyerEvents from "../../../config/appsFlyerEvents";
import { errorMessage } from "../../utils/errorMessage";
import AddressField, {
  IAddressFormat,
  addressErrorObj,
  CkycAddressFormat,
} from "../../Profile/AddressField/AddressField";
import DocumentBrowse, {
  DocDetailFormat,
} from "../../UI/DocumentBrowse/DocumentBrowse";
import {
  AextractAadhaar,
  AextractDl,
  AextractPassport,
  AextractVoterid,
  AgetPdf,
  AGetUploadedDocument,
  AmaskAadhaar,
  ADownloadDocument,
  ASaveDocumentDetails,
  AGetDocumentList,
  DropOffLogAPI,
  AGetDocStatus,
} from "../../Services/dashboard/docVerificationAPIServices";
import { AUploadDocument } from "../../Services/dashboard/brokerageServices";
import { uploadDocObj } from "../../DocumentVerification/DocVerificationForm/DocVerificationForm";
import Checkbox from "../../UI/Checkbox/Checkbox";
import {
  ASaveAddressDetails,
  AVerifyDocumentData,
  GetAddressDetails,
  ASavePersonalDocument,
} from "../../Services/registration/manualFlowService";
import { repairAddressWithConditions } from "../../utils/validation";
import {
  completeModuleStatus,
  incompleteStageNavigation,
  localStorageGetItem,
  localStorageSetItem,
  utmDurationInfoObj,
} from "../../Services/globalService";
import Calender from "../../UI/Calender/Calender";
import AddressInfoField, {
  addressInfoErrorObj,
  IAddressInfoFormat,
} from "./AddressInfoField";
import { decryptJwtToken } from "../../Services/dashboard/encryptionNew";
import { disabledUploadForEsign } from "../../utils/eSignSubmitHandler";
import SampleAadharPopup from "../SampleFolderPopups/SampleAadharPopup";
import SampleDrivingLicensePopup from "../SampleFolderPopups/SampleDrivingLicense";
import SampleVoterIDPopup from "../SampleFolderPopups/SampleVoterIdPopup";
import SamplePassportPopup from "../SampleFolderPopups/SamplePassportPopup";
import SampleAadharMobileViewProps from "../SampleFolderPopups/SampleAadharPopupMobileView";
import SampleSDLMobileViewProps from "../SampleFolderPopups/SampleDLMobile";
import SampleVoterIDMobileViewProps from "../SampleFolderPopups/SampleVoterIDMobile";
import SamplePassportMobileViewProps from "../SampleFolderPopups/SamplePassportMobile";
import DeviceContext from "../../Services/identifyDevice";
import InfoModal from "../../UI/InfoModal/InfoModal";
import EdModal from "../../UI/EdModal/EdModal";
import { AGetStageCompletionStatus } from "../../Services/registration/continueApiService";

const identificationListPerm = [
  {
    display: "Aadhaar Card",
    value: 117,
  },
  {
    display: "Driving License",
    value: 118,
  },
  {
    display: "Voter ID",
    value: 116,
  },
  {
    display: "Passport",
    value: 114,
  },
];
const identificationListCorr = [
  {
    display: "Aadhaar Card",
    value: 10,
  },
  {
    display: "Driving License",
    value: 13,
  },
  {
    display: "Voter ID",
    value: 12,
  },
  {
    display: "Passport",
    value: 11,
  },
];

export const initialAddressObj: any = {
  addressLine1: "",
  City: "",
  Country: "",
  District: "",
  PinCode: "",
  State: "",
  Area: "",
  CountryCode: 0,
  StateCode: 0,
  clientName: "",
};

export const initialDocObj: DocDetailFormat = {
  id: "",
  disable: true,
  uploadPer: 0,
  hideProgress: false,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  isWatsappFlag: false,
};
export const initialPanDocObj: DocDetailFormat = {
  id: "",
  disable: false,
  uploadPer: 0,
  hideProgress: true,
  fileName: "",
  showFile: true,
  imgUrl: "",
  documentcategory: "",
  documentCategoryId: "",
  documentId: 0,
  mimeType: "",
  base64: "",
  iscropped: false,
  isWatsappFlag: false,
};
let localAadharNo: any;
const PersoanlInfo = (props: any) => {
  const [dlExtractData, setDlExtractData] = React.useState<any>();
  const [dlUploadInformation, setDLUploadInformation] = React.useState<any>();
  const [renderSamplePopups, setRenderSamplePopup] =
    React.useState<boolean>(false);
  const [renderCorrSamplePopups, setRenderCorrSamplePopup] =
    React.useState<boolean>(false);
  const [corrDLExtractData, setCorrDLExtractData] = React.useState<any>();
  const [regectedDocStatus, setRegectedDocStatus] = React.useState<
    Array<object>
  >([{}]);
  const [corrDlUploadInformation, setCorrDLUploadInformation] =
    React.useState<any>();
  const [startTime, setStartTime] = React.useState<Date>(new Date());
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [errCode, setErrCode] = React.useState<number | string>();
  const [permAddListError, setPermAddListError] = useState<any>("");
  const [permSecAddListError, setPermSecAddListError] = useState<any>("");
  const [corrAddListError, setCorrAddListError] = useState<any>("");
  const [corrSecAddListError, setCorrSecAddListError] = useState<any>("");
  const [addressFileFound, setAddressFileFound] =
    React.useState<boolean>(false);
  const [correspondanceFileFound, setCorrespondanceFileFound] =
    React.useState<boolean>(false);
  const [anotherFile, setAnotherFile] = React.useState<boolean>(false);
  const [secondDoc, setSecondDoc] = useState<boolean>(false);
  const [corrSecondDoc, setCorrSecondDoc] = useState<boolean>(false);
  const [corrAnotherFile, setCorrAnotherFile] = React.useState<boolean>(false);
  const [documentList, setDocumentList] = React.useState<any>();
  const [cordocumentList, setCorDocumentList] = React.useState<any>();
  const [permAddList, setPermAddList] = useState<any>([]);
  const [defaultAddress, setDefaultAddress] = useState<string>("");
  const [defaultCorrAddress, setDefaultCorrAddress] = useState<string>("");

  const [permAddressObj, setPermAddressObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [permSecondAddressObj, setPermSecondAddressObj] =
    useState<DocDetailFormat>({ ...initialPanDocObj });
  const [corrAddressObj, setCorrAddressObj] = useState<DocDetailFormat>({
    ...initialDocObj,
  });
  const [corrSecondAddressObj, setCorrSecondAddressObj] = useState<any>({
    ...initialPanDocObj,
  });
  const [permanentAddress, setPermanentAddress] = React.useState<any>({
    ...initialAddressObj,
  });
  const [correspondanceAddress, setCorrespondanceAddress] = React.useState<any>(
    { ...initialAddressObj }
  );
  const [permErrorObj, setPermErrorObj] = React.useState<{
    [key in keyof IAddressInfoFormat]?: string;
  }>({
    ...addressInfoErrorObj,
  });
  const [corrErrorObj, setCorrErrorObj] = React.useState<{
    [key in keyof IAddressInfoFormat]?: string;
  }>({
    ...addressInfoErrorObj,
  });
  const [isNewPermAddress, setIsNewPermAddress] = useState<boolean>(false);
  const [isNewCorrAddress, setIsNewCorrAddress] = useState<boolean>(false);
  const [addressName, setAddressName] = React.useState<string>("");
  const [corrAddressName, setCorrAddressName] = React.useState<string>("");
  const [sameAsPermanent, setSameAsPermanent] = React.useState<boolean>(true);
  const [errors, setErrors] = React.useState<any>({
    permanentAddress: "",
    correspondanceAddress: "",
  });
  const [drivingFlag, setDrivingFlag] = React.useState<boolean>(true);
  const [corrsDrivingFlag, SetCorrsDrivingFlag] = React.useState<boolean>(true);
  const [qrVerifiedAadhar, setQrVerifiedAadhar] =
    React.useState<boolean>(false);
  const [autoQCFlagPer, setAutQcFlagPer] = React.useState<boolean>(false);
  const [autoQCFlagCor, setAutQcFlagCor] = React.useState<boolean>(false);
  const [qrVerifiedCorrsAadhar, setQrVerifiedCorrsAadhar] =
    React.useState<boolean>(false);
  const [uploadPayload, setUploadPayload] = React.useState<any>(null);
  const [uploadPayloadCorr, setUploadPayloadCorr] = React.useState<any>(null);
  const [showInfoModal, setShowInfoModal] = React.useState<any>(false);

  // const [aadharNo, setAadharNo] = React.useState<string>("");
  // const history = useHistory();
  const navigate = useNavigate()
  const dropOffObj = () => {
    let userId = 0;
    //  console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = parseInt(tokenMainObj?.UserId?.toString());
    }
    const stageInfoObj = {
      applicationid: GlobalStore?.applicationID,
      accountCagtegory: GlobalStore?.stageStatus?.accountcategory
        ? GlobalStore?.stageStatus?.accountcategory
        : GlobalStore?.accountcategory,
      stageOrderId: 13,
      userId: userId?.toString(),
      rmAssisted: GlobalStore?.stageStatus?.rmassisted,
    };
    DropOffLogAPI(() => { }, stageInfoObj);
  };
  const shouldDisable = () => {
    let disabled: boolean = false;
    if (
      GlobalStore?.stageStatus?.first_esign_initiated !== null &&
      GlobalStore?.stageStatus?.first_esign_initiated !== undefined &&
      GlobalStore?.stageStatus?.first_esign_initiated
    ) {
      disabled = true;
    }
    return disabled;
  };
  React.useEffect(() => {
    const clientPartialDetails_ao = JSON.parse(
      localStorageGetItem("clientPartialDetails_ao") || "{}"
    );
    // localAadharNo = JSON.parse(
    //   localStorageGetItem("aadharNumber") || ""
    // );
    clientPartialDetails_ao.emailID = GlobalStore.user.email;
    clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
    clientPartialDetails_ao.dob = GlobalStore.dob;
    dropOffObj();
    localStorageSetItem(
      "clientPartialDetails_ao",
      JSON.stringify(clientPartialDetails_ao)
    );
    AGetDocStatus(getDocumentStatus, GlobalStore.applicationID);
    getDocumentDetails();
    // setTimeout(() => {

    // }, 1000);
    GetAddressDetails(getKycDetails, GlobalStore.applicationID);
    setIsLoading(true);
    AGetUploadedDocument(getUploadedDoc, GlobalStore.applicationID);
    // setTimeout(() => {

    // }, 1000);

    // getDocumentDetails();
  }, []);
  const getDocumentStatus = (res: any) => {
    if (!res || res.error) {
      // setErrCode("164- Failed to get the document status for the application.");
      setErrCode(errCode + res.error);
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR125" });
    } else {
      if (res.data) {
        const regectedDoc = JSON.parse(res.data).filter(
          (item: any) => item.Status === "Rejected"
        );
        setRegectedDocStatus(regectedDoc);
      } else {
        gtmService({
          action: "GetDocumentDetails",
          label: "ERROR || ERR125-S",
        });
      }
    }
  };
  const getUISamplePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case aadhaarDocumnetId:
        return (
          <SampleAadharPopup
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
            parentClassName="aadhar-popup"
          />
        );
      case dlDocumentId:
        return (
          <SampleDrivingLicensePopup
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
            parentClassName="driving-popup"
          />
        );
      case voterIdDocumentId:
        return (
          <SampleVoterIDPopup
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
            parentClassName="voter-popup"
          />
        );
      case passportDocumnetId:
        return (
          <SamplePassportPopup
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
            parentClassName="passport-popup"
          />
        );
    }
  };
  const getUISampleMobilePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case aadhaarDocumnetId:
        return (
          <SampleAadharMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
      case dlDocumentId:
        return (
          <SampleSDLMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
      case voterIdDocumentId:
        return (
          <SampleVoterIDMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
      case passportDocumnetId:
        return (
          <SamplePassportMobileViewProps
            showPopup={renderSamplePopups}
            setShowPopup={setRenderSamplePopup}
          />
        );
    }
  };
  const getUICorrSamplePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case corrAadhaarDocumnetId:
        return (
          <SampleAadharPopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corraadhar-popup"
          />
        );
      case corrDlDocumentId:
        return (
          <SampleDrivingLicensePopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corrDL-popup"
          />
        );
      case corrVoterIdDocumentId:
        return (
          <SampleVoterIDPopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corrVoter-popup"
          />
        );
      case corrPassportDocumnetId:
        return (
          <SamplePassportPopup
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
            parentClassName="corrPassport-popup"
          />
        );
    }
  };
  const getUISampleCorrMobilePopups = (addressProodID: any) => {
    switch (addressProodID) {
      case corrAadhaarDocumnetId:
        return (
          <SampleAadharMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
      case corrDlDocumentId:
        return (
          <SampleSDLMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
      case corrVoterIdDocumentId:
        return (
          <SampleVoterIDMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
      case corrPassportDocumnetId:
        return (
          <SamplePassportMobileViewProps
            showPopup={renderCorrSamplePopups}
            setShowPopup={setRenderCorrSamplePopup}
          />
        );
    }
  };
  const getDocumentDetails = () => {
    AGetDocumentList((res: any) => {
      if (res.data) {
        let listObj = JSON.parse(res.data);
        const corrAddObjlist = listObj.filter(
          (x: any) => x.DocumentCategory === "Address Proof Correspondence"
        );
        const permAddObjlist = listObj.filter(
          (x: any) => x.DocumentCategory === "Address Proof Permanent"
        );
        console.log("corr", corrAddObjlist, "per", permAddObjlist);
        if (corrAddObjlist.length) {
          let corrAddressCopy = { ...corrAddressObj };
          corrAddressCopy.documentcategory = "Address Proof Correspondance";
          corrAddressCopy.documentCategoryId =
            corrAddObjlist[0].DocumentCategoryId;
          setCorrAddressObj(corrAddressCopy);
        } else {
          let corrAddressCopy = { ...corrAddressObj };
          corrAddressCopy.documentcategory = "Address Proof Correspondance";
          corrAddressCopy.documentCategoryId = "3";
          setCorrAddressObj(corrAddressCopy);
        }
        if (permAddObjlist.length) {
          let permAddressCopy = { ...permAddressObj };
          permAddressCopy.documentcategory = "Address Proof Permanent";
          permAddressCopy.documentCategoryId =
            permAddObjlist[0].DocumentCategoryId;
          setPermAddressObj(permAddressCopy);
        }
      }
    }, GlobalStore.applicationID);
  };
  function getKycDetails(res: any) {
    try {
      setIsLoading(true);
      if (!res || res.error) {
        setIsLoading(false);
        setErrCode(res.error);
      } else {
        if (res.data) {
          let responseObj = JSON.parse(res.data);
          if (responseObj.AddressDetails) {
            const clientPartialDetails_ao = JSON.parse(
              localStorageGetItem("clientPartialDetails_ao") || "{}"
            );
            clientPartialDetails_ao.applicationId = GlobalStore.applicationID;
            clientPartialDetails_ao.leadID = GlobalStore.leadId;
            clientPartialDetails_ao.clientPrimaryDetailId =
              responseObj.ClientPrimaryDetailID;

            clientPartialDetails_ao.sameAsPermanent =
              responseObj.Corrsaddraspermanent !== null &&
                responseObj.Corrsaddraspermanent !== undefined
                ? responseObj.Corrsaddraspermanent
                : true;
            // clientPartialDetails_ao.corrAddress =
            //   responseObj.AddressDetails.objCorrespondenceAddressDetails.correspondenceaddressline1;
            if (responseObj?.DocumentNumber?.length === 4) {
              clientPartialDetails_ao.aadharNo = responseObj.DocumentNumber
                ? responseObj.DocumentNumber.slice(-4)
                : "";
              GlobalStore.personaldetails.aadharNo =
                localStorageSetItem(
                  "aadharNumber",
                  GlobalStore.personaldetails.aadharNo
                );
              localAadharNo = responseObj.DocumentNumber.slice(-4);
              localStorageSetItem("aadharNumber", localAadharNo);
            }

            let permResultObj =
              responseObj.AddressDetails.objPermanentAddressDetails;
            if (permResultObj) {
              const permAddObj = { ...permanentAddress };
              permAddObj.addressLine1 =
                (permResultObj.permanentaddressline1 || "") +
                (permResultObj.permanentaddressline2 || "") +
                (permResultObj.permanentaddressline3 || "") +
                (permResultObj.permanentaddressline4 || "");
              clientPartialDetails_ao.addressLine1 = permAddObj.addressLine1;
              if (responseObj.Corrsaddraspermanent === true)
                clientPartialDetails_ao.corrAddress = permAddObj.addressLine1;
              permAddObj.Area = permResultObj.permanentarea;
              permAddObj.City = permResultObj.permanentcity;
              permAddObj.PinCode = permResultObj.permanentpincode;
              permAddObj.District = permResultObj.permanentdistrict;
              permAddObj.State = permResultObj.permanentstate;
              permAddObj.StateCode = permResultObj.permanentstatecode;
              permAddObj.Country = permResultObj.permanentcountry;
              permAddObj.CountryCode = permResultObj.permanentcountrycode;
              permAddObj.clientName = permResultObj.documentname;
              permAddObj.documentNumber = permResultObj.documentnumber;
              permAddObj.dateOfIssue = permResultObj?.documentissuedate
                ? permResultObj?.documentissuedate
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
                : "";
              permAddObj.dateOfExpiry = permResultObj?.documentexpirydate
                ? permResultObj?.documentexpirydate
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
                : "";
              if (
                permResultObj?.documentnumber?.length === 4 ||
                permResultObj?.documentnumber?.includes("XXXX")
              ) {
                permAddObj.documentNumber =
                  permResultObj?.documentnumber?.length === 4
                    ? `XXXX XXXX ${permResultObj.documentnumber}`
                    : permResultObj?.documentnumber;
                delete permAddObj.dateOfExpiry;
                delete permAddObj.dateOfIssue;
              }
              if (permResultObj?.documentnumber?.length === 10) {
                delete permAddObj.dateOfExpiry;
              }

              setPermanentAddress(permAddObj);
              // for AO-1395 KYC/KRA address proof reject
            }
            let corrsResultObj =
              responseObj.AddressDetails.objCorrespondenceAddressDetails;
            if (corrsResultObj) {
              const corrAddObj = { ...correspondanceAddress };
              corrAddObj.addressLine1 =
                corrsResultObj.correspondenceaddressline1 +
                corrsResultObj.correspondenceaddressline2 +
                (corrsResultObj.correspondenceaddressline3 || "") +
                (corrsResultObj.correspondenceaddressline4 || "");
              corrAddObj.Area = corrsResultObj.correspondancearea;
              corrAddObj.City = corrsResultObj.correspondancecity;
              corrAddObj.PinCode = corrsResultObj.correspondancepincode;
              corrAddObj.District = corrsResultObj.correspondancedistrict;
              corrAddObj.State = corrsResultObj.correspondancestate;
              corrAddObj.StateCode = corrsResultObj.correspondancestatecode;
              corrAddObj.Country = corrsResultObj.correspondancecountry;
              corrAddObj.CountryCode = corrsResultObj.correspondancecountrycode;
              corrAddObj.clientName = corrsResultObj.documentname;
              corrAddObj.documentNumber = corrsResultObj.documentnumber;
              corrAddObj.dateOfIssue = corrsResultObj?.documentissuedate
                ? corrsResultObj?.documentissuedate
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
                : "";
              corrAddObj.dateOfExpiry = corrsResultObj?.documentexpirydate
                ? corrsResultObj?.documentexpirydate
                  ?.split("-")
                  ?.reverse()
                  ?.join("/")
                : "";
              if (
                corrsResultObj?.documentnumber?.length === 4 ||
                corrsResultObj?.documentnumber?.includes("XXXX")
              ) {
                corrAddObj.documentNumber =
                  corrsResultObj?.documentnumber?.length === 4
                    ? `XXXX XXXX ${corrsResultObj.documentnumber}`
                    : corrsResultObj?.documentnumber;
                delete corrAddObj.dateOfIssue;
                delete corrAddObj.dateOfExpiry;
              }
              if (corrsResultObj?.documentnumber?.length === 10) {
                delete corrAddObj.dateOfExpiry;
              }
              if (responseObj.Corrsaddraspermanent === false)
                clientPartialDetails_ao.corrAddress = corrAddObj.addressLine1;
              setCorrespondanceAddress(corrAddObj);
            }
            clientPartialDetails_ao.isManual = true;
            localStorageSetItem(
              "clientPartialDetails_ao",
              JSON.stringify(clientPartialDetails_ao)
            );
            setSameAsPermanent(
              responseObj.Corrsaddraspermanent === false ? false : true
            );
          }
          setSameAsPermanent(
            responseObj.Corrsaddraspermanent === false ? false : true
          );
        }

        setIsLoading(false);
      }
    } catch (error) {
      console.log("error in catch", error);
    }
  }

  const getUploadedDoc = async (res: any) => {
    console.log("getUploadedDoc || ==", res);
    if (!res || res.error) {
      // setErrCode(164)
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124" });
    } else if (res.data) {
      const uplDoc = JSON.parse(res.data);
      console.log("getUploadedDoc", uplDoc);

      const isCorrAddressProof = uplDoc.filter(
        (x: any) => x.DocumentCategory === "Address Proof Correspondence"
      );
      const isPermAddressProof = uplDoc.filter(
        (x: any) => x.DocumentCategory === "Address Proof Permanent"
      );
      if (isCorrAddressProof.length > 0) {
        setIsLoading(true);

        // permanentAddress.addressLine1 = permExtractionData?.address;
        // permanentAddress.City = permExtractionData?.district;
        // permanentAddress.State = permExtractionData?.state;
        // permanentAddress.PinCode = permExtractionData.pincode;
        // permanentAddress.clientName = permExtractionData?.name_on_card;
        // permanentAddress.documentNumber
        ADownloadDocument(
          getCorrAddressImage,
          isCorrAddressProof[0].FileName,
          isCorrAddressProof[0].UploadedDocPath
        );
        setCorrespondanceFileFound(true);
        setCorrespondanceAddress((correspondanceAddress: any) => {
          if (
            correspondanceAddress !== null &&
            correspondanceAddress !== undefined &&
            !!correspondanceAddress?.addressLine1 &&
            correspondanceAddress?.addressLine1 !== "" &&
            !!correspondanceAddress?.documentNumber &&
            correspondanceAddress?.documentNumber !== ""
          ) {
            if (isCorrAddressProof[0].DocumentName === "Aadhaar Card") {
              setDefaultCorrAddress("Aadhaar Card");
              setQrVerifiedCorrsAadhar(true);
            } else if (isCorrAddressProof[0].DocumentName === "Passport") {
              setDefaultCorrAddress("Passport");
            } else if (isCorrAddressProof[0].DocumentName === "Voter ID") {
              setDefaultCorrAddress("Voter ID");
            } else if (
              isCorrAddressProof[0].DocumentName === "Driving License"
            ) {
              setDefaultCorrAddress("Driving License");
            } else if (
              isCorrAddressProof[0].DocumentName === "Nrega Job Card"
            ) {
              setDefaultCorrAddress("Nrega Job Card");
            }
            setCorrAddressObj((corrAddressObj) => {
              corrAddressObj.id = "corrAddress";
              corrAddressObj.disable = false;
              corrAddressObj.uploadPer = 100;
              corrAddressObj.fileName = `${GlobalStore.applicationID}_Corrospondance Address`;
              corrAddressObj.showFile = false;
              corrAddressObj.hideProgress = false;
              corrAddressObj.documentCategoryId =
                isCorrAddressProof[0].DocumentCategoryId;
              corrAddressObj.documentcategory =
                isCorrAddressProof[0].DocumentCategory;
              corrAddressObj.documentId = isCorrAddressProof[0].DocumentId;
              corrAddressObj.mimeType = isCorrAddressProof[0].MimeType;
              corrAddressObj.documentCategoryId =
                isCorrAddressProof[0].DocumentCategoryId;
              return corrAddressObj;
            });

            // setCorrAddressObj(corrAddressObj);
          } else if (
            correspondanceAddress !== null &&
            correspondanceAddress !== undefined &&
            !!correspondanceAddress?.addressLine1 &&
            correspondanceAddress?.addressLine1 !== ""
          ) {
            if (isCorrAddressProof[0].DocumentName === "Aadhaar Card") {
              setDefaultCorrAddress("Aadhaar Card");
              setQrVerifiedCorrsAadhar(true);
            } else if (isCorrAddressProof[0].DocumentName === "Passport") {
              setDefaultCorrAddress("Passport");
            } else if (isCorrAddressProof[0].DocumentName === "Voter ID") {
              setDefaultCorrAddress("Voter ID");
            } else if (
              isCorrAddressProof[0].DocumentName === "Driving License"
            ) {
              setDefaultCorrAddress("Driving License");
            } else if (
              isCorrAddressProof[0].DocumentName === "Nrega Job Card"
            ) {
              setDefaultCorrAddress("Nrega Job Card");
            }
            setCorrAddressObj((corrAddressObj) => {
              corrAddressObj.id = "corrAddress";
              corrAddressObj.disable = false;
              corrAddressObj.uploadPer = 100;
              corrAddressObj.fileName = `${GlobalStore.applicationID}_Corrospondance Address`;
              corrAddressObj.showFile = false;
              corrAddressObj.hideProgress = false;
              corrAddressObj.documentCategoryId =
                isCorrAddressProof[0].DocumentCategoryId;
              corrAddressObj.documentcategory =
                isCorrAddressProof[0].DocumentCategory;
              corrAddressObj.documentId = isCorrAddressProof[0].DocumentId;
              corrAddressObj.mimeType = isCorrAddressProof[0].MimeType;
              corrAddressObj.documentCategoryId =
                isCorrAddressProof[0].DocumentCategoryId;
              return corrAddressObj;
            });
          }
          return correspondanceAddress;
        });
        // setTimeout(() => {

        // }, 1000);
      }
      if (
        GlobalStore?.stageStatus?.isaddressstagecompleted == false &&
        GlobalStore?.stageStatus?.bpm_pd_status == 2
      ) {
        setPermanentAddress(initialAddressObj);
        setCorrespondanceAddress(initialAddressObj);
      }
      if (isPermAddressProof.length > 0) {
        setIsLoading(true);
        ADownloadDocument(
          getAddressImage,
          isPermAddressProof[0].FileName,
          isPermAddressProof[0].UploadedDocPath
        );
        setAddressFileFound(true);
        setPermanentAddress((permanentAddress: any) => {
          if (
            permanentAddress !== null &&
            permanentAddress !== undefined &&
            !!permanentAddress?.addressLine1 &&
            permanentAddress?.addressLine1 !== "" &&
            !!permanentAddress?.documentNumber &&
            permanentAddress?.documentNumber !== ""
          ) {
            if (isPermAddressProof[0].DocumentName === "Aadhaar Card") {
              setDefaultAddress("Aadhaar Card");
              setQrVerifiedAadhar(true);
            } else if (isPermAddressProof[0].DocumentName === "Passport") {
              setDefaultAddress("Passport");
            } else if (isPermAddressProof[0].DocumentName === "Voter ID") {
              setDefaultAddress("Voter ID");
            } else if (
              isPermAddressProof[0].DocumentName === "Driving License"
            ) {
              setDefaultAddress("Driving License");
            } else if (
              isPermAddressProof[0].DocumentName === "Nrega Job Card"
            ) {
              setDefaultAddress("Nrega Job Card");
            }
            setPermAddressObj((permAddressObj) => {
              permAddressObj.id = "permAddress";
              permAddressObj.disable = false;
              permAddressObj.uploadPer = 100;
              permAddressObj.fileName = `${GlobalStore.applicationID}_Permanent Address`;
              permAddressObj.showFile = false;
              permAddressObj.hideProgress = false;
              permAddressObj.documentCategoryId =
                isPermAddressProof[0].DocumentCategoryId;
              permAddressObj.documentcategory =
                isPermAddressProof[0].DocumentCategory;
              permAddressObj.documentId = isPermAddressProof[0].DocumentId;
              permAddressObj.mimeType = isPermAddressProof[0].MimeType;
              permAddressObj.documentCategoryId =
                isPermAddressProof[0].DocumentCategoryId;
              return permAddressObj;
            });

            // setPermAddressObj(permAddressObj);
          } else if (
            permanentAddress !== null &&
            permanentAddress !== undefined &&
            !!permanentAddress?.addressLine1 &&
            permanentAddress?.addressLine1 !== ""
          ) {
            if (isPermAddressProof[0].DocumentName === "Aadhaar Card") {
              setDefaultAddress("Aadhaar Card");
              setQrVerifiedAadhar(true);
            } else if (isPermAddressProof[0].DocumentName === "Passport") {
              setDefaultAddress("Passport");
            } else if (isPermAddressProof[0].DocumentName === "Voter ID") {
              setDefaultAddress("Voter ID");
            } else if (
              isPermAddressProof[0].DocumentName === "Driving License"
            ) {
              setDefaultAddress("Driving License");
            } else if (
              isPermAddressProof[0].DocumentName === "Nrega Job Card"
            ) {
              setDefaultAddress("Nrega Job Card");
            }
            setPermAddressObj((permAddressObj) => {
              permAddressObj.id = "permAddress";
              permAddressObj.disable = false;
              permAddressObj.uploadPer = 100;
              permAddressObj.fileName = `${GlobalStore.applicationID}_Permanent Address`;
              permAddressObj.showFile = false;
              permAddressObj.hideProgress = false;
              permAddressObj.documentCategoryId =
                isPermAddressProof[0].DocumentCategoryId;
              permAddressObj.documentcategory =
                isPermAddressProof[0].DocumentCategory;
              permAddressObj.documentId = isPermAddressProof[0].DocumentId;
              permAddressObj.mimeType = isPermAddressProof[0].MimeType;
              permAddressObj.documentCategoryId =
                isPermAddressProof[0].DocumentCategoryId;
              return permAddressObj;
            });
          }
          return permanentAddress;
        });
        // setDefaultPermAddressProof(true);
        // setTimeout(() => {

        // }, 1000);
      }
    } else {
      setPermAddressObj((permAddressObj) => {
        return permAddressObj;
      });
      setCorrAddressObj((corrAddressObj) => {
        return corrAddressObj;
      });
      gtmService({ action: "GetDocumentDetails", label: "ERROR || ERR124-S" });
    }
    setIsLoading(false);
  };

  const getAddressImage = async (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR129",
      });
    } else {
      if (res.data) {
        const base64 = getbase64(res.data.base64document, permAddressObj);

        setPermAddressObj((permAddressObj) => {
          permAddressObj.imgUrl = getbase64(
            res.data.base64document,
            permAddressObj
          );
          permAddressObj.mimeType = detectMimeType(res.data.base64document);
          return permAddressObj;
        });
        setIsLoading(false);
        console.log("-perm-BASE64");
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR129-S",
        });
      }
    }
  };

  function getbase64(dataString: string, obj: DocDetailFormat) {
    let mimeType = detectMimeType(dataString);
    return "data:" + mimeType + ";base64," + dataString;
  }

  const getCorrAddressImage = async (res: any) => {
    if (!res || res.error) {
      // setErrCode(164)
      gtmService({
        action: "DownloadDocumentFromS3",
        label: "ERROR || ERR130",
      });
    } else {
      if (res.data) {
        setIsLoading(false);
        const base64 = getbase64(res.data.base64document, corrAddressObj);

        // corrAddressObj.base64 = base64;
        setCorrAddressObj((corrAddressObj) => {
          corrAddressObj.imgUrl = base64;
          corrAddressObj.mimeType = detectMimeType(res.data.base64document);
          return corrAddressObj;
        });
        console.log("-corr-BASE64");
      } else {
        gtmService({
          action: "DownloadDocumentFromS3",
          label: "ERROR || ERR130-S",
        });
      }
    }
  };

  const handlePermanentAddress = (val: any) => {
    if (val && val.value) {
      permAddressObj.disable = false;
      permAddressObj.documentId = val.value;
      setPermAddressObj(permAddressObj);
      setDefaultAddress(val.display);
      setDrivingFlag(true);
      setQrVerifiedAadhar(false);
      // setAadharNo("");
      switch (val.display) {
        case "Aadhaar Card":
          setPermanentAddress({
            ...initialAddressObj,
            documentNumber: "",
          });
          setPermErrorObj({
            ...permErrorObj,
            documentNumber: undefined,
          });
          break;
        case "Driving License":
          setPermanentAddress({
            ...initialAddressObj,
            documentNumber: "",
            dateOfIssue: "",
            dateOfExpiry: "",
          });
          setPermErrorObj({
            ...permErrorObj,
            documentNumber: undefined,
            dateOfIssue: undefined,
            dateOfExpiry: undefined,
          });
          break;
        case "Voter ID":
          setPermanentAddress({
            ...initialAddressObj,
            documentNumber: "",
            dateOfIssue: "",
          });
          setPermErrorObj({
            ...permErrorObj,
            documentNumber: undefined,
            dateOfIssue: undefined,
          });
          break;
        case "Passport":
          setPermanentAddress({
            ...initialAddressObj,
            documentNumber: "",
            dateOfIssue: "",
            dateOfExpiry: "",
          });
          setPermErrorObj({
            ...permErrorObj,
            documentNumber: undefined,
            dateOfIssue: undefined,
            dateOfExpiry: undefined,
          });
          break;
        default:
          setPermanentAddress({ ...initialAddressObj });
          setPermErrorObj({
            ...permErrorObj,
          });
          break;
      }
    }
  };
  const handleAddressBlur = (value: any, identificationDetailType: string) => {
    if (typeof value === "object") {
      setErrors({ ...errors, [identificationDetailType]: "" });
    } else {
      setErrors({
        ...errors,
        [identificationDetailType]: "Please select from dropdown'",
      });
    }
  };
  const handleCorrespondenceAddress = (val: any) => {
    if (val && val.value) {
      setCorrAddressObj((corrAddressObj) => {
        corrAddressObj.disable = false;
        corrAddressObj.documentId = val.value;
        return corrAddressObj;
      });

      // setCorrAddressObj(corrAddressObj);
      setDefaultCorrAddress(val.display);
      setQrVerifiedCorrsAadhar(false);
      SetCorrsDrivingFlag(true);
      // setAadharNo("");
      switch (val.display) {
        case "Aadhaar Card":
          setCorrespondanceAddress({
            ...initialAddressObj,
            documentNumber: "",
          });
          setCorrErrorObj({
            ...corrErrorObj,
            documentNumber: undefined,
          });
          break;
        case "Driving License":
          setCorrespondanceAddress({
            ...initialAddressObj,
            documentNumber: "",
            dateOfIssue: "",
            dateOfExpiry: "",
          });
          setCorrErrorObj({
            ...corrErrorObj,
            documentNumber: undefined,
            dateOfIssue: undefined,
            dateOfExpiry: undefined,
          });
          break;
        case "Voter ID":
          setCorrespondanceAddress({
            ...initialAddressObj,
            documentNumber: "",
            dateOfIssue: "",
          });
          setCorrErrorObj({
            ...corrErrorObj,
            documentNumber: undefined,
            dateOfIssue: undefined,
          });
          break;
        case "Passport":
          setCorrespondanceAddress({
            ...initialAddressObj,
            documentNumber: "",
            dateOfIssue: "",
            dateOfExpiry: "",
          });
          setCorrErrorObj({
            ...corrErrorObj,
            documentNumber: undefined,
            dateOfIssue: undefined,
            dateOfExpiry: undefined,
          });
          break;
        default:
          setCorrespondanceAddress({ ...initialAddressObj });
          setCorrErrorObj({
            ...corrErrorObj,
          });
          break;
      }
    }
  };

  function onFirstPermAddressRemove(val: any) {
    setPermAddressObj({
      ...initialDocObj,
      disable: false,
      documentId: permAddressObj.documentId,
      documentCategoryId: permAddressObj?.documentCategoryId,
    });
    setPermanentAddress({ ...initialAddressObj });
  }
  function onSecondPermAddressRemove(val: any) {
    setPermSecondAddressObj({
      ...initialPanDocObj,
      documentId: permAddressObj.documentId,
      documentCategoryId: permAddressObj?.documentCategoryId,
    });
    setPermanentAddress({ ...initialAddressObj });
  }
  function getMimeType(base64String?: string) {
    // Split the string to get the metadata part before the comma
    if (base64String !== null && base64String !== undefined) {
      const mimeType = base64String.match(/^data:([^;]+);base64,/);

      // Return MIME type if present, otherwise return null
      return mimeType ? mimeType[1] : ".";
    }
    return ".";
  }
  const popularSignatures = {
    JVBERi0: "application/pdf",
    R0lGODdh: "image/gif",
    R0lGODlh: "image/gif",
    iVBORw0KGgo: "image/png",
    "/9j/": "image/jpg",
    Qk02U: "image/bmp",
  };

  function detectMimeType(base64 = "") {
    for (const [signature, type] of Object.entries(popularSignatures)) {
      if (base64.startsWith(signature)) {
        return type;
      }
    }
    return undefined; // Explicitly return undefined if no match is found
  }
  function onPermanantSecondAddressUploadDocument(
    val: any,
    fileName: string,
    id: string,
    type: string
  ) {
    setIsLoading(true);

    setPermSecondAddressObj(permSecondAddressObj);
    if (
      fileName.split(".")[1] !== "pdf" &&
      permSecondAddressObj.documentId !== 125
    ) {
      setPermSecondAddressObj((permSecondAddressObj) => {
        permSecondAddressObj.imgUrl = "";
        permSecondAddressObj.fileName = fileName;
        permSecondAddressObj.base64 = val!.split(",")[1];
        permSecondAddressObj.documentCategoryId =
          permAddressObj?.documentCategoryId;
        return permSecondAddressObj;
      });
      setSecondDoc(true);
      if (
        permAddressObj.documentId === aadhaarDocumnetId ||
        permAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: "Address Proof Permanent",
          documentid: permSecondAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadharNew(res, id, fileName, type),
          aadharObj
        );
      } else {
        setPermSecondAddressObj((permSecondAddressObj) => {
          permSecondAddressObj.imgUrl = "";
          permSecondAddressObj.fileName = fileName;
          permSecondAddressObj.base64 = val!.split(",")[1];
          permSecondAddressObj.documentCategoryId =
            permAddressObj?.documentCategoryId;
          return permSecondAddressObj;
        });
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        uploadAadhar(true, { id, fileName, type, uploadId: id }, true);
        // if (permAddressObj.documentId === passportDocumnetId) {
        //   setIsLoading(true);
        //   AextractPassport(
        //     (res: any) =>
        //       storeOcrData(res, addressOCR, (res: any) => {
        //         if (res !== null && res !== undefined)
        //           uploadAadhar(
        //             true,
        //             { id, fileName, type, uploadId: id },
        //             true
        //           );
        //       }),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === voterIdDocumentId) {
        //   setIsLoading(true);
        //   AextractVoterid(
        //     (res: any) =>
        //       storeOcrData(res, addressOCR, (res: any) => {
        //         if (res !== null && res !== undefined)
        //           uploadAadhar(
        //             true,
        //             { id, fileName, type, uploadId: id },
        //             true
        //           );
        //       }),
        //     addressOCR
        //   );
        // } else if (permAddressObj.documentId === dlDocumentId) {
        //   setIsLoading(true);

        //   AextractDl((res: any) => {
        //     storeOcrData(res, addressOCR, (res: any) => {
        //       if (res !== null && res !== undefined)
        //         uploadAadhar(true, { id, fileName, type, uploadId: id }, true);
        //     });
        //   }, addressOCR);
        // }
      }
    } else {
      setIsLoading(false);
      setSecondDoc(false);
      setAnotherFile(false);
    }
  }
  const onPermanentAddressUploadDocument = (
    val: any,
    fileName: string,
    id: string,
    type: string
  ) => {
    setIsLoading(true);
    if (fileName.split(".")[1] !== "pdf" && permAddressObj.documentId !== 125) {
      setSecondDoc(true);
      setPermAddressObj((permAddressObj) => {
        permAddressObj.base64 = val!.split(",")[1];
        permAddressObj.fileName = fileName;
        return permAddressObj;
      });
      if (permAddressObj.documentId === aadhaarDocumnetId) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: "Address Proof Permanent",
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadharNew(res, id, fileName, type),
          aadharObj
        );
      } else {
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        if (permAddressObj.documentId === passportDocumnetId) {
          setIsLoading(true);
          AextractPassport(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, true);
              }),
            addressOCR
          );
        } else if (permAddressObj.documentId === voterIdDocumentId) {
          setIsLoading(true);
          AextractVoterid(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, true);
              }),
            addressOCR
          );
        } else if (permAddressObj.documentId === dlDocumentId) {
          setIsLoading(true);
          setDLUploadInformation({
            id: id,
            fileName: fileName,
            type: type,
            uploadId: id,
          });
          AextractDl((res: any) => {
            storeOcrData(res, addressOCR, (res: any) => {
              if (res !== null && res !== undefined)
                uploadAadhar(false, { id, fileName, type, uploadId: id }, true);
            });
          }, addressOCR);
        }
      }
    } else {
      setPermAddressObj((permAddressObj) => {
        permAddressObj.base64 = val!.split(",")[1];
        permAddressObj.fileName = fileName;
        return permAddressObj;
      });
      setSecondDoc(false);
      setAnotherFile(false);
      if (permAddressObj.documentId === aadhaarDocumnetId) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: "Address Proof Permanent",
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadharNew(res, id, fileName, type),
          aadharObj
        );
      } else {
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        if (permAddressObj.documentId === passportDocumnetId) {
          setIsLoading(true);
          AextractPassport(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, true);
              }),
            addressOCR
          );
        } else if (permAddressObj.documentId === voterIdDocumentId) {
          setIsLoading(true);
          AextractVoterid(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, true);
              }),
            addressOCR
          );
        } else if (permAddressObj.documentId === dlDocumentId) {
          setIsLoading(true);
          setDLUploadInformation({
            id: id,
            fileName: fileName,
            type: type,
            uploadId: id,
          });
          AextractDl((res: any) => {
            storeOcrData(res, addressOCR, (res: any) => {
              if (res !== null && res !== undefined)
                uploadAadhar(false, { id, fileName, type, uploadId: id }, true);
            });
          }, addressOCR);
        }
      }
    }
  };
  const onCorrespondanceAddressUploadDocument = (
    val: any,
    fileName: string,
    id: string,
    type: string
  ) => {
    setIsLoading(true);
    setCorrAddressObj((corrAddressObj) => {
      corrAddressObj.imgUrl = "";
      corrAddressObj.base64 = val!.split(",")[1];
      corrAddressObj.fileName = fileName;
      return corrAddressObj;
    });

    //    setCorrAddressObj(corrAddressObj);
    console.log("Changes in address", fileName, val);
    if (fileName.split(".")[1] !== "pdf" && corrAddressObj.documentId !== 133) {
      setCorrSecondDoc(true);

      if (
        corrAddressObj.documentId === aadhaarDocumnetId ||
        corrAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: "Corr Address Proof Permanent",
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadharNew(res, id, fileName, type),
          aadharObj
        );
      } else {
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: corrAddressObj.documentcategory,
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        if (corrAddressObj.documentId === corrPassportDocumnetId) {
          setIsLoading(true);
          AextractPassport(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, false);
              }),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
          setIsLoading(true);
          AextractVoterid(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, false);
              }),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrDlDocumentId) {
          console.log("INSIDE DL block");
          setCorrDLUploadInformation({ id, fileName, type, uploadId: id });
          setIsLoading(true);
          AextractDl((res: any) => {
            storeOcrData(res, addressOCR, (res: any) => {
              if (res !== null && res !== undefined)
                uploadAadhar(false, { id, fileName, type, uploadId: id }, false);
            });
          }, addressOCR);
        }
      }
    } else {
      // if PDF
      setCorrSecondDoc(false);
      setCorrAnotherFile(false);

      if (
        corrAddressObj.documentId === aadhaarDocumnetId ||
        corrAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: corrAddressObj.base64,
          documentcategory: "Corr Address Proof Permanent",
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        AmaskAadhaar(
          (res: any) => maskedAadharNew(res, id, fileName, type),
          aadharObj
        );
      } else {
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: corrAddressObj.documentcategory,
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        if (corrAddressObj.documentId === corrPassportDocumnetId) {
          setIsLoading(true);
          AextractPassport(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, false);
              }),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
          setIsLoading(true);
          AextractVoterid(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                if (res !== null && res !== undefined)
                  uploadAadhar(false, { id, fileName, type, uploadId: id }, false);
              }),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrDlDocumentId) {
          setIsLoading(true);
          setCorrDLUploadInformation({ id, fileName, type, uploadId: id });
          AextractDl((res: any) => {
            storeOcrData(res, addressOCR, (res: any) => {
              if (res !== null && res !== undefined)
                uploadAadhar(false, { id, fileName, type, uploadId: id }, false);
            });
          }, addressOCR);
        }
      }
    }
  };
  const onCorrespondanceSecondAddressUploadDocument = (
    val: any,
    fileName: string,
    id: string,
    type: string
  ) => {
    setIsLoading(true);
    corrSecondAddressObj.imgUrl = "";
    corrSecondAddressObj.fileName = fileName;
    corrSecondAddressObj.base64 = val!.split(",")[1];
    corrSecondAddressObj.documentCategoryId = corrAddressObj.documentCategoryId;
    setCorrSecondAddressObj(corrSecondAddressObj);
    if (
      fileName.split(".")[1] !== "pdf" &&
      corrSecondAddressObj.documentId !== 133
    ) {
      setCorrSecondDoc(true);
      if (
        corrAddressObj.documentId === aadhaarDocumnetId ||
        corrAddressObj.documentId === corrAadhaarDocumnetId
      ) {
        const aadharObj = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: "Address Proof Permanent",
          documentid: corrSecondAddressObj.documentId,
          source: DIY,
        };
        console.log("Aadhar Detected");
        AmaskAadhaar(
          (res: any) => maskedAadharNew(res, id, fileName, type),
          aadharObj
        );
      } else {
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: val!.split(",")[1],
          documentcategory: corrAddressObj.documentcategory,
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        uploadAadhar(true, { id, fileName, type, uploadId: id }, false);
        // if (corrAddressObj.documentId === corrPassportDocumnetId) {
        //   setIsLoading(true);
        //   AextractPassport(
        //     (res: any) =>
        //       storeOcrData(res, addressOCR, (res: any) => {
        //         if (res !== null && res !== undefined)
        //           uploadAadhar(
        //             true,
        //             { id, fileName, type, uploadId: id },
        //             false
        //           );
        //       }),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
        //   setIsLoading(true);
        //   AextractVoterid(
        //     (res: any) =>
        //       storeOcrData(res, addressOCR, (res: any) => {
        //         if (res !== null && res !== undefined)
        //           uploadAadhar(
        //             true,
        //             { id, fileName, type, uploadId: id },
        //             false
        //           );
        //       }),
        //     addressOCR
        //   );
        // } else if (corrAddressObj.documentId === corrDlDocumentId) {
        //   setIsLoading(true);
        //   AextractDl((res: any) => {
        //     storeOcrData(res, addressOCR, (res: any) => {
        //       if (res !== null && res !== undefined)
        //         uploadAadhar(true, { id, fileName, type, uploadId: id }, false);
        //     });
        //   }, addressOCR);
        // }
      }
    } else {
      setCorrSecondDoc(false);
      setCorrAnotherFile(false);
    }
  };
  const maskedAadharNew = (
    res: any,
    id: string,
    fileName: string,
    type: string
  ) => {

    if (!res || res.error) {
      setIsLoading(false);
      // gtmService({ action: "ExtractDocumentData", label: "ERROR || ERR138" });
      if (res.data.error) {
        setErrCode("Aadhar Masking failed: " + res.data.error);
        setIsLoading(false);
      } else {
        setErrCode(res.error);
      }
    } else if (res.data) {
      if (res.data.error) {
        setErrCode("Aadhar Masking failed: " + res.data.error);
        setIsLoading(false);
      } else {
        let addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: permAddressObj.base64,
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        if (id === "permAddress") {
          if (res.data.result.id_number_found) {
            setPermAddressObj((permAddressObj) => {
              permAddressObj.base64 = res.data.result.base64_image;
              permAddressObj.mimeType = "image/jpeg";
              permAddressObj.fileName =
                permAddressObj.fileName.split(".")[0] + ".jpg";
              type = "image/jpeg";
              return permAddressObj;
            });
            addressOCR.base64document = res.data.result.base64_image;
            addressOCR.documentcategory = permAddressObj.documentcategory;
            addressOCR.documentid = permAddressObj.documentId;
          }
        } else if (id === "permSecondAddress") {
          if (res.data.result.id_number_found) {
            setPermSecondAddressObj((permSecondAddressObj) => {
              permSecondAddressObj.base64 = res.data.result.base64_image;
              permSecondAddressObj.mimeType = "image/jpeg";
              permSecondAddressObj.fileName =
                permSecondAddressObj.fileName.split(".")[0] + ".jpg";
              type = "image/jpeg";
              return permSecondAddressObj;
            });
            // setPermSecondAddressObj(permSecondAddressObj);
          }
        } else if (id === "corrAddress") {
          if (res.data.result.id_number_found) {
            setCorrAddressObj((corrAddressObj) => {
              corrAddressObj.documentCategoryId =
                corrAddressObj.documentCategoryId;
              corrAddressObj.base64 = res.data.result.base64_image;
              corrAddressObj.mimeType = "image/jpeg";
              corrAddressObj.fileName =
                corrAddressObj.fileName.split(".")[0] + ".jpg";
              type = "image/jpeg";
              return corrAddressObj;
            });
            addressOCR.base64document = res.data.result.base64_image;
            addressOCR.documentcategory = corrAddressObj.documentcategory;
            addressOCR.documentid = corrAddressObj.documentId;
          }
        } else {
          if (res.data.result.id_number_found) {
            setCorrSecondAddressObj((corrSecondAddressObj: any) => {
              corrSecondAddressObj.base64 = res.data.result.base64_image;
              corrSecondAddressObj.mimeType = "image/jpeg";
              corrSecondAddressObj.fileName =
                corrSecondAddressObj.fileName.split(".")[0] + ".jpg";
              type = "image/jpeg";
              return corrSecondAddressObj;
            });
          }
        }
        if (id === "permSecondAddress") {
          uploadAadhar(
            true,
            { id: id, fileName: fileName, type: type, uploadId: id },
            true
          );
        } else if (id == "corrSecondAddress") {
          uploadAadhar(
            true,
            { id: id, fileName: fileName, type: type, uploadId: id },
            false
          );
        } else
          AextractAadhaar(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                uploadAadhar(false, {
                  id: id,
                  fileName: fileName,
                  type: type,
                  uploadId: id,
                }, id === "permAddress" || id === "permSecondAddress");
              }),
            addressOCR,
            "OCR"
          );
      }
    } else {
      // gtmService({
      //   action: "ExtractDocumentData",
      //   label: "ERROR || ERR138-S",
      // });
    }
  };
  const getPDFDataNew = (res: any, idObj: any) => {
    if (!res || res.error) {
      setErrCode(res.error);
      // gtmService({
      //   action: "MargeMultipleImagestoPDF",
      //   label: "ERROR || ERR136",
      // });
      setIsLoading(false);
    } else {
      if (res.data) {
        let mergeBase64 = res.data.Mergedimagespdfbase64;
        setIsLoading(false);
        setAddressName(res.data.Guid);
        permAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        if (permAddressObj.documentId === aadhaarDocumnetId) {
          setIsLoading(true);
          AextractAadhaar(
            (res: any) => {
              storeOcrData(res, addressOCR, (res1: any) => {
                uploadAadhar(false, idObj, true, mergeBase64);
              });
            },
            addressOCR,
            "OCR"
          );
        } else if (permAddressObj.documentId === passportDocumnetId) {
          // uploadAadhar(false, idObj, false, res.data.Mergedimagespdfbase64);
          setIsLoading(true);
          AextractPassport(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                uploadAadhar(false, idObj, false, mergeBase64);
              }),
            addressOCR
          );
        } else if (permAddressObj.documentId === voterIdDocumentId) {
          // uploadAadhar(false, idObj, false, res.data.Mergedimagespdfbase64);
          setIsLoading(true);
          AextractVoterid(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                uploadAadhar(false, idObj, false, mergeBase64);
              }),
            addressOCR
          );
        } else if (permAddressObj.documentId === dlDocumentId) {
          // uploadAadhar(false, idObj, false, res.data.Mergedimagespdfbase64);
          setIsLoading(true);
          AextractDl((res: any) => {
            // uploadAadhar(false, idObj, false, mergeBase64);
            storeOcrData(res, addressOCR, (res1: any) => {
              uploadAadhar(false, idObj, true, mergeBase64);
            });
          }, addressOCR);
        }
      } else {
        // gtmService({
        //   action: "MargeMultipleImagestoPDF",
        //   label: "ERROR || ERR136-S",
        // });
      }
    }
  };
  const getCorrPDFDataNew = (res: any, idObj?: any) => {
    if (!res || res.error) {
      gtmService({
        action: "MargeMultipleImagestoPDF",
        label: "ERROR || ERR137",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        //  setCorrAddressName(res.data.Guid);
        let mergeBase64 = res.data.Mergedimagespdfbase64;
        corrAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: corrAddressObj.documentcategory,
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        if (corrAddressObj.documentId === corrAadhaarDocumnetId) {
          setIsLoading(true);
          AextractAadhaar(
            (res: any) =>
              storeOcrData(res, addressOCR, (res1: any) => {
                uploadAadhar(false, idObj, false, mergeBase64);
              }),
            addressOCR,
            "OCR"
          );
        } else if (corrAddressObj.documentId === corrPassportDocumnetId) {
          //setIsLoading(false);
          // uploadAadhar(false, idObj, res.data.Mergedimagespdfbase64);
          AextractPassport(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                uploadAadhar(false, idObj, false, mergeBase64);
              }),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
          setIsLoading(true);
          // uploadAadhar(false, idObj, res.data.Mergedimagespdfbase64);
          AextractVoterid(
            (res: any) =>
              storeOcrData(res, addressOCR, (res: any) => {
                uploadAadhar(false, idObj, false, mergeBase64);
              }),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrDlDocumentId) {
          setIsLoading(true);
          //uploadAadhar(false, idObj, res.data.Mergedimagespdfbase64);
          AextractDl((res: any) => {
            storeOcrData(res, addressOCR, (res: any) => {
              uploadAadhar(false, idObj, false, mergeBase64);
            });
          }, addressOCR);
        }
      } else {
        // gtmService({
        //   action: "MargeMultipleImagestoPDF",
        //   label: "ERROR || ERR137-S",
        // });
      }
    }
  };
  const uploadAadhar = (
    isSecondFileUpload?: boolean,
    idObj?: any,
    isPermanent?: boolean,
    margeBase64?: string,
    callbackFunction?: Function
  ) => {
    debugger
    const localObj = idObj;
    const { id, fileName, type, uploadId } = idObj;
    if (isSecondFileUpload !== undefined && isSecondFileUpload) {
      if (isPermanent) {
        let uploadImageObj = {
          applicationId: GlobalStore.applicationID,
          image1: permAddressObj.base64,
          image2: permSecondAddressObj.base64,
          imagename1: permAddressObj.fileName,
          imagename2: permSecondAddressObj.fileName,
          clientPrimaryDetailId: GlobalStore?.clientPrimaryDetailId,
          panNo: GlobalStore?.personaldetails?.pan,
          leadId: GlobalStore?.leadId,
          documentId: permAddressObj?.documentId,
          documentCategoryId: permAddressObj?.documentCategoryId?.toString(),
          documentNumber: permanentAddress?.documentNumber,
        };
        AgetPdf((res: any) => {
          getPDFDataNew(res, localObj);
        }, uploadImageObj);
      } else {
        let uploadImageObj = {
          applicationId: GlobalStore.applicationID,
          image1: corrAddressObj.base64,
          image2: corrSecondAddressObj.base64,
          imagename1: corrAddressObj.fileName,
          imagename2: corrSecondAddressObj.fileName,
          clientPrimaryDetailId: GlobalStore?.clientPrimaryDetailId,
          panNo: GlobalStore?.personaldetails?.pan,
          leadId: GlobalStore?.leadId,
          documentId: corrAddressObj?.documentId,
          documentCategoryId: corrAddressObj?.documentCategoryId?.toString(),
          documentNumber: correspondanceAddress?.documentNumber,
        };
        AgetPdf((res: any) => {
          getCorrPDFDataNew(res, localObj);
        }, uploadImageObj);
      }
    } else {
      let uploadObj: uploadDocObj;
      let saveDocumentDetails = [];
      if (uploadId === "permAddress") {
        setPermanentAddress((permanentAddress: any) => {
          let mimeType: string = getMimeType(permAddressObj.base64);
          if (mimeType !== undefined && mimeType == ".") {
            let detectMimeTypeVar = detectMimeType(permAddressObj.base64);
            if (detectMimeTypeVar !== undefined) {
              mimeType = detectMimeTypeVar;
            }
          }
          console.log("documentNumber debug upload aadhar function", permanentAddress);

          let savepermAddressObj = {
            documentCategoryId: permAddressObj.documentCategoryId?.toString(),
            documentId: permAddressObj.documentId?.toString(),
            documentexpirydate: "",
            fileName:
              permAddressObj?.documentId == aadhaarDocumnetId
                ? permAddressObj.fileName.split(".")[0] + ".jpg"
                : permAddressObj?.fileName,
            isfilecropped: true,
            mimeType: mimeType,
            panno: GlobalStore.personaldetails.pan,
            isWatsappFlag: permAddressObj.isWatsappFlag,
            personaldetailsid: "0",
            //autoqc: qrVerifiedAadhar ? qrVerifiedAadhar : false,
            autoqc: autoQCFlagPer,
            DocumentIssueDate:
              permanentAddress?.dateOfIssue !== null &&
                permanentAddress?.dateOfIssue !== undefined
                ? permanentAddress?.dateOfIssue
                  ?.split("/")
                  ?.reverse()
                  ?.join("-")
                : null,
            DocumentName: permanentAddress?.clientName,
            documentNumber:
              defaultAddress === "Aadhaar Card"
                ? permanentAddress.documentNumber.slice(-4)
                : permanentAddress.documentNumber,
            IsDocumentVerified: drivingFlag ? drivingFlag : false,
            IsQRVerified: qrVerifiedAadhar ? qrVerifiedAadhar : false,
          };
          setDrivingFlag((drivingFlag) => {
            savepermAddressObj.IsDocumentVerified = drivingFlag;
            return drivingFlag;
          });
          saveDocumentDetails.push(savepermAddressObj);

          return permanentAddress;
        });
        uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: permAddressObj.base64 || "",
          filename: permAddressObj.fileName,
          panNo: GlobalStore?.personaldetails.pan,
        };
      } else if (uploadId === "permSecondAddress") {
        uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: permSecondAddressObj.base64 || "",
          filename: permSecondAddressObj.fileName,
          panNo: GlobalStore?.personaldetails.pan,
        };
        let mimeType: string = getMimeType(permSecondAddressObj.base64);
        if (mimeType !== undefined && mimeType == ".") {
          let detectMimeTypeVar = detectMimeType(permSecondAddressObj.base64);
          if (detectMimeTypeVar !== undefined) {
            mimeType = detectMimeTypeVar;
          }
        }
        let savepermAddressObj = {
          documentCategoryId:
            permSecondAddressObj.documentCategoryId?.toString(),
          documentId:
            permSecondAddressObj.documentId?.toString() != "0"
              ? permSecondAddressObj.documentId?.toString()
              : permAddressObj?.documentId,
          documentexpirydate: "",
          fileName:
            permAddressObj?.documentId == aadhaarDocumnetId
              ? permSecondAddressObj.fileName.split(".")[0] + ".jpg"
              : permSecondAddressObj?.fileName,
          isfilecropped: true,
          mimeType: mimeType,
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: permSecondAddressObj.isWatsappFlag,
          personaldetailsid: "0",
          //autoqc: qrVerifiedAadhar ? qrVerifiedAadhar : false,
          autoqc: autoQCFlagPer,
          DocumentIssueDate: permanentAddress?.dateOfIssue
            ? permanentAddress?.dateOfIssue?.split("/")?.reverse()?.join("-")
            : null,
          DocumentName: permanentAddress?.clientName,
          documentNumber:
            defaultAddress === "Aadhaar Card"
              ? permanentAddress.documentNumber.slice(-4)
              : permanentAddress.documentNumber,
          IsDocumentVerified: drivingFlag ? drivingFlag : false,
          IsQRVerified: qrVerifiedAadhar ? qrVerifiedAadhar : false,
        };
        setDrivingFlag((drivingFlag) => {
          savepermAddressObj.IsDocumentVerified = drivingFlag;
          return drivingFlag;
        });
        if (
          margeBase64 !== null &&
          margeBase64 !== undefined &&
          margeBase64 !== "" &&
          detectMimeType(margeBase64) !== undefined
        ) {
          let mimeType = detectMimeType(margeBase64);
          if (mimeType !== undefined) {
            if (mimeType == "application/pdf")
              uploadObj.filename =
                `${GlobalStore.applicationID}_Permanent Address` + ".pdf";
            savepermAddressObj.mimeType = mimeType;
          }
        }
        saveDocumentDetails.push(savepermAddressObj);
      } else if (uploadId === "corrAddress") {
        uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: corrAddressObj.base64 || "",
          filename: corrAddressObj.fileName,
          panNo: GlobalStore?.personaldetails.pan,
        };
        setCorrAddressObj((corrAddressObj) => {
          return corrAddressObj;
        });
        let mimeType: string = getMimeType(corrAddressObj.base64);
        if (mimeType !== undefined && mimeType == ".") {
          let detectMimeTypeVar = detectMimeType(corrAddressObj.base64);
          if (detectMimeTypeVar !== undefined) {
            mimeType = detectMimeTypeVar;
          }
        }
        let saveCorrAddressObj = {
          documentCategoryId: corrAddressObj.documentCategoryId?.toString(),
          documentId: corrAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName:
            corrAddressObj?.documentId == corrAadhaarDocumnetId
              ? corrAddressObj.fileName.split(".")[0] + ".jpg"
              : corrAddressObj.fileName,
          isfilecropped: true,
          mimeType: mimeType,
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: corrAddressObj.isWatsappFlag,
          personaldetailsid: "0",
          // autoqc: qrVerifiedCorrsAadhar ? qrVerifiedCorrsAadhar : false,
          autoqc: autoQCFlagCor,
          DocumentIssueDate: correspondanceAddress?.dateOfIssue
            ? correspondanceAddress?.dateOfIssue
              ?.split("/")
              ?.reverse()
              ?.join("-")
            : null,
          DocumentName: correspondanceAddress?.clientName,
          documentNumber:
            defaultAddress === "Aadhaar Card"
              ? correspondanceAddress.documentNumber.slice(-4)
              : correspondanceAddress.documentNumber,
          IsDocumentVerified: corrsDrivingFlag ? corrsDrivingFlag : false,
          IsQRVerified: qrVerifiedCorrsAadhar ? qrVerifiedCorrsAadhar : false,
        };
        SetCorrsDrivingFlag((corrsDrivingFlag) => {
          saveCorrAddressObj.IsDocumentVerified = corrsDrivingFlag;
          return corrsDrivingFlag;
        });

        saveDocumentDetails.push(saveCorrAddressObj);
      } else {
        uploadObj = {
          applicationid: GlobalStore.applicationID,
          base64document: corrSecondAddressObj.base64 || "",
          filename: corrSecondAddressObj.fileName,
          panNo: GlobalStore?.personaldetails.pan,
        };
        let mimeType: string = getMimeType(corrSecondAddressObj.base64);
        if (mimeType !== undefined && mimeType == ".") {
          let detectMimeTypeVar = detectMimeType(corrSecondAddressObj.base64);
          if (detectMimeTypeVar !== undefined) {
            mimeType = detectMimeTypeVar;
          }
        }
        let saveCorrAddressObj = {
          documentCategoryId:
            corrSecondAddressObj.documentCategoryId?.toString(),
          documentId: corrSecondAddressObj.documentId?.toString(),
          documentexpirydate: "",
          fileName:
            corrAddressObj?.documentId == corrAadhaarDocumnetId
              ? corrSecondAddressObj.fileName.split(".")[0] + ".jpg"
              : corrSecondAddressObj?.fileName,
          isfilecropped: true,
          mimeType: mimeType,
          panno: GlobalStore.personaldetails.pan,
          isWatsappFlag: corrSecondAddressObj.isWatsappFlag,
          personaldetailsid: "0",
          // autoqc: qrVerifiedCorrsAadhar ? qrVerifiedCorrsAadhar : false,
          autoqc: autoQCFlagCor,
          DocumentIssueDate: correspondanceAddress?.dateOfIssue
            ? correspondanceAddress?.dateOfIssue
              ?.split("/")
              ?.reverse()
              ?.join("-")
            : null,
          DocumentName: correspondanceAddress?.clientName,
          documentNumber:
            defaultAddress === "Aadhaar Card"
              ? correspondanceAddress.documentNumber.slice(-4)
              : correspondanceAddress.documentNumber,
          IsDocumentVerified: corrsDrivingFlag ? corrsDrivingFlag : false,
          IsQRVerified: qrVerifiedCorrsAadhar ? qrVerifiedCorrsAadhar : false,
        };
        if (
          margeBase64 !== null &&
          margeBase64 !== undefined &&
          margeBase64 !== "" &&
          detectMimeType(margeBase64) !== undefined
        ) {
          let mimeType = detectMimeType(margeBase64);
          if (mimeType !== undefined) {
            if (mimeType == "application/pdf")
              uploadObj.filename =
                `${GlobalStore.applicationID}_Corrospondance Address` + ".pdf";
            saveCorrAddressObj.mimeType = mimeType;
          }
        }
        saveDocumentDetails.push(saveCorrAddressObj);
      }
      const saveObj = {
        applicationId: GlobalStore.applicationID,
        clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
        documentInfo: saveDocumentDetails,
        leadId: GlobalStore.leadId,
        // objUTM_Info: objUTM_Info,
      };
      if (
        margeBase64 !== null &&
        margeBase64 !== undefined &&
        margeBase64 !== ""
      ) {
        uploadObj.base64document = margeBase64;
      }
      if (GlobalStore.isKRA == false && disabledUploadForEsign()) {
        setErrCode("Account is already submitted.");
      } else {
        debugger
        setIsLoading(false);
        if (isPermanent) {
          setUploadPayload({
            uploadObj,
            saveObj,
            id,
            fileName,
            type,
            callbackFunction,
          });
        } else {
          setUploadPayloadCorr({
            uploadObj,
            saveObj,
            id,
            fileName,
            type,
            callbackFunction,
          });
        }
        // AUploadDocument(
        //   (res: any) =>
        //     getUploadResNew(
        //       res,
        //       id,
        //       uploadObj.base64document,
        //       uploadObj.filename,
        //       callbackFunction
        //     ),
        //   uploadObj,
        //   (event: ProgressEvent) => onUploadProgress(event, id, fileName, type),
        //   saveObj
        // );
      }
    }
  };

  function onFirstCorrAddressRemove(val: any) {
    setCorrAddressObj({
      ...initialDocObj,
      disable: false,
      documentId: corrAddressObj.documentId,
      documentCategoryId: corrAddressObj?.documentCategoryId,
    });
    setCorrespondanceAddress({ ...initialAddressObj });
  }
  function onSecondCorrAddressRemove(val: any) {
    setCorrSecondAddressObj({
      ...initialPanDocObj,
      documentId: corrAddressObj.documentId,
      documentCategoryId: corrAddressObj?.documentCategoryId,
    });
    setCorrespondanceAddress({ ...initialAddressObj });
  }

  const addDocument = () => {
    if (secondDoc) {
      setAnotherFile(true);
    } else {
      setAnotherFile(false);
    }
  };
  const addCorrDocument = () => {
    if (corrSecondDoc) {
      setCorrAnotherFile(true);
    } else {
      setCorrAnotherFile(false);
    }
  };

  function handErrorForFileUpload(id: string, res: any) {
    if (id === "permAddress") {
      setPermAddListError(res.error);
    }
    if (id === "permSecondAddress") {
      setPermSecAddListError(res.error);
    }
    if (id === "corrAddress") {
      setCorrAddListError(res.error);
    }

    if (id === "corrSecondAddress") {
      setCorrSecAddListError(res.error);
    }
  }
  const getUploadResNew = (
    res: any,
    id: string,
    val: any,
    fileName: string,
    callbackFunction?: Function
  ) => {
    if (!res || res.error) {
      // gtmService({ action: "UploadDocumentToS3", label: "ERROR || ERR140" });
      setIsLoading(false);
      handErrorForFileUpload(id, res);
      setErrCode(res.error);
    } else {
      if (res.data) {
        setErrCode("");
        if (id === "permAddress" && fileName.split(".")[1] === "pdf") {
          setIsLoading(false);
          setPermAddListError("");
          setIsNewPermAddress(true);
        } else if (id === "permAddress" && fileName.split(".")[1] !== "pdf") {
          setPermAddListError("");
          setIsNewPermAddress(true);
          setAddressName(res.data.Guid);
          setIsLoading(false);
        } else if (id === "permSecondAddress") {
          setPermSecAddListError("");
          setIsLoading(false);
          setIsNewPermAddress(true);
        } else if (id === "corrAddress" && fileName.split(".")[1] === "pdf") {
          setIsLoading(false);
          setCorrAddListError("");
          setIsNewCorrAddress(true);
          setCorrAddressName(res.data.Guid);
        } else if (id === "corrAddress" && fileName.split(".")[1] !== "pdf") {
          setIsNewCorrAddress(true);
          setCorrAddListError("");
          setCorrAddressName(res.data.Guid);
          setIsLoading(false);
        } else if (
          id === "corrAddress" &&
          fileName.split(".")[1] !== "pdf" &&
          corrSecondAddressObj.base64 !== undefined
        ) {
          setIsLoading(false);
          setCorrAddListError("");
          setIsNewCorrAddress(true);
        } else if (id === "corrSecondAddress") {
          setIsLoading(false);
          setCorrSecAddListError("");
          setIsNewCorrAddress(true);
        }
        if (callbackFunction !== undefined) {
          callbackFunction();
        }
      } else {
        setErrCode("1365- Error in uploading the file.");
        // gtmService({
        //   action: "UploadDocumentToS3",
        //   label: "ERROR || ERR140-S",
        // });
      }
    }
  };

  const storeOcrData = (res: any, id: any, callback?: Function) => {
    if (!res || res.error) {
      if (res?.data?.error) {
        setErrCode(res?.data?.error);
        // gtmService({
        //   action: "ExtractDocumentData",
        //   label: "ERROR || ERR134-E",
        // });
      } else {
        setErrCode(res.error);
        // gtmService({ action: "ExtractDocumentData", label: "ERROR || ERR134" });
      }
      setIsLoading(false);
    } else if (res.data) {
      if (res?.data?.error) {
        setErrCode(res?.data?.error);
        setIsLoading(false);
        // gtmService({
        //   action: "ExtractDocumentData",
        //   label: "ERROR || ERR134-E",
        // });
      } else {
        setErrCode("");

        setIsLoading(false);
        if (id.documentid === aadhaarDocumnetId) {
          GlobalStore.aadhaarOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";
          if (!GlobalStore.aadhaarOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of Aadhar"
            );
            setPermanentAddress({ ...initialAddressObj });
          } else {
            let permExtractionData = res?.data?.result?.extraction_output;
            const idNumber = permExtractionData?.id_number;
            setPermanentAddress((permanentAddress: any) => {
              permanentAddress.addressLine1 = permExtractionData?.address;
              permanentAddress.City = permExtractionData?.district;
              permanentAddress.State = permExtractionData?.state;
              permanentAddress.PinCode = permExtractionData.pincode;
              permanentAddress.clientName = permExtractionData?.name_on_card;
              permanentAddress.documentNumber = idNumber ? `XXXX XXXX ${idNumber.slice(-4)}` : "";
              return permanentAddress;
            });
            if (sameAsPermanent) {
              setCorrespondanceAddress((corrAddres: any) => {
                if (
                  corrAddres?.clientName == "" ||
                  corrAddres?.clientName == null ||
                  corrAddres?.clientName == undefined
                ) {
                  corrAddres.clientName = permExtractionData?.name_on_card;
                }
                return corrAddres;
              });
            }
            // setAadharNo(permExtractionData?.id_number);
            //if (res?.data?.result?.qr_detected) {
            if (
              res?.data?.result?.qr_detected &&
              res?.data?.result?.qr_encoded &&
              res?.data?.result?.qr_scannable
            ) {
              setAutQcFlagPer(true);
            } else {
              setAutQcFlagPer(false);
            }

            if (res?.data?.result?.qr_detected) {
              setQrVerifiedAadhar(true);
              setErrCode("");
            } else {
              setQrVerifiedAadhar(false);
              setErrCode("Please upload a valid Document");
            }
            if (
              permExtractionData?.id_number === null ||
              permExtractionData?.id_number === ""
            ) {
              alert("please Upload front side of Adhaar as well");
            } else {
              if (callback !== undefined) callback(true);
            }
          }
        } else if (id.documentid === passportDocumnetId) {
          GlobalStore.passportOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";

          if (!GlobalStore.passportOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of passport"
            );
            setPermanentAddress({ ...initialAddressObj });
          } else {
            let permExtractionData = res?.data?.result?.extraction_output;
            // setPermanentAddress({
            //   ...permanentAddress,
            //   addressLine1: permExtractionData?.address,
            //   City: permExtractionData?.district,
            //   State: permExtractionData?.state,
            //   PinCode: permExtractionData.pincode,
            //   clientName: permExtractionData?.name_on_card,
            //   documentNumber: permExtractionData?.id_number,
            //   // dateOfIssue: typeof permExtractionData?.date_of_issue == "string" ? permExtractionData?.date_of_issue : undefined,
            //   // dateOfExpiry: typeof permExtractionData?.date_of_expiry == "string" ? permExtractionData?.date_of_expiry : undefined,
            //   dateOfIssue: permExtractionData?.date_of_issue,
            //   dateOfExpiry: permExtractionData?.date_of_expiry,
            // });
            setPermanentAddress((permanentAddress: any) => {
              permanentAddress.addressLine1 = permExtractionData?.address;
              permanentAddress.City = permExtractionData?.district;
              permanentAddress.State = permExtractionData?.state;
              permanentAddress.PinCode = permExtractionData.pincode;
              permanentAddress.clientName = permExtractionData?.name_on_card;
              permanentAddress.documentNumber = permExtractionData?.id_number;
              permanentAddress.dateOfIssue = permExtractionData?.date_of_issue;
              permanentAddress.dateOfExpiry =
                permExtractionData?.date_of_expiry;
              return permanentAddress;
            });
            console.log(
              typeof permExtractionData.date_of_issue == "string",
              "||",
              typeof permExtractionData.date_of_expiry,
              "===?",
              new Date() < permExtractionData?.date_of_expiry
            );
            if (
              permExtractionData.id_number === null ||
              permExtractionData.id_number === ""
            ) {
              alert("please Upload other side of Passport as well");
            } else {
              if (callback !== undefined) callback(true);
            }
          }
        } else if (id.documentid === voterIdDocumentId) {
          GlobalStore.voterIdOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";

          if (!GlobalStore.voterIdOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of voter id"
            );
            setPermanentAddress({ ...initialAddressObj });
          } else {
            let permExtractionData = res?.data?.result?.extraction_output;
            // setPermanentAddress({
            //   ...permanentAddress,
            //   addressLine1: permExtractionData?.address,
            //   City: permExtractionData?.district,
            //   State: permExtractionData?.state,
            //   PinCode: permExtractionData.pincode,
            //   clientName: permExtractionData?.name_on_card,
            //   documentNumber: permExtractionData?.id_number,
            // });
            setPermanentAddress((permanentAddress: any) => {
              permanentAddress.addressLine1 = permExtractionData?.address;
              permanentAddress.City = permExtractionData?.district;
              permanentAddress.State = permExtractionData?.state;
              permanentAddress.PinCode = permExtractionData.pincode;
              permanentAddress.clientName = permExtractionData?.name_on_card;
              permanentAddress.documentNumber = permExtractionData?.id_number;
              return permanentAddress;
            });
            if (
              permExtractionData.id_number === null ||
              permExtractionData.id_number === ""
            ) {
              alert("Please upload the other side of the Voter ID as well.");
            } else {
              if (callback !== undefined) callback(true);
            }
          }
        } else if (id.documentid === dlDocumentId) {
          GlobalStore.dlOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";
          if (!GlobalStore.dlOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of driving license"
            );
            setPermanentAddress({ ...initialAddressObj });
          } else {
            let permExtractionData = res?.data?.result?.extraction_output;

            // setPermanentAddress({
            //   ...permanentAddress,
            //   addressLine1: permExtractionData?.address,
            //   City: permExtractionData?.district,
            //   State: permExtractionData?.state,
            //   PinCode: permExtractionData.pincode,
            //   documentNumber: permExtractionData?.id_number,
            //   clientName: permExtractionData?.name_on_card,
            //   dateOfIssue:
            //     moment(
            //       moment(permExtractionData?.issue_dates, "DD/MM/YYYY")
            //     ).format("YYYY/MM/DD") == "Invalid date"
            //       ? undefined
            //       : moment(
            //           moment(permExtractionData?.issue_dates, "DD/MM/YYYY")
            //         ).format("DD/MM/YYYY"),
            //   dateOfExpiry:
            //     moment(
            //       moment(permExtractionData?.date_of_validity, "DD/MM/YYYY")
            //     ).format("YYYY/MM/DD") == "Invalid date"
            //       ? undefined
            //       : moment(
            //           moment(permExtractionData?.date_of_validity, "DD/MM/YYYY")
            //         ).format("DD/MM/YYYY"),
            // });
            setPermanentAddress((permanentAddress: any) => {
              permanentAddress.addressLine1 = permExtractionData?.address;
              permanentAddress.City = permExtractionData?.district;
              permanentAddress.State = permExtractionData?.state;
              permanentAddress.PinCode = permExtractionData.pincode;
              permanentAddress.clientName = permExtractionData?.name_on_card;
              permanentAddress.documentNumber = permExtractionData?.id_number;
              permanentAddress.dateOfIssue =
                moment(
                  moment(permExtractionData?.issue_dates, "DD/MM/YYYY")
                ).format("YYYY/MM/DD") == "Invalid date"
                  ? undefined
                  : moment(
                    moment(permExtractionData?.issue_dates, "DD/MM/YYYY")
                  ).format("DD/MM/YYYY");
              permanentAddress.dateOfExpiry =
                moment(
                  moment(permExtractionData?.date_of_validity, "DD/MM/YYYY")
                ).format("YYYY/MM/DD") == "Invalid date"
                  ? undefined
                  : moment(
                    moment(permExtractionData?.date_of_validity, "DD/MM/YYYY")
                  ).format("DD/MM/YYYY");
              return permanentAddress;
            });
            setDlExtractData(permExtractionData);

            if (callback !== undefined) {
              callback(true);
            }
            setIsLoading(false);
            let verifyDrivingObj = {
              ActionName: "verify_with_source",
              ApplicationId: GlobalStore.applicationID,
              DateOfBirth: permExtractionData?.date_of_birth,
              DocumentType: "ind_driving_license",
              Source: "DIY",
              //IdNumber: permExtractionData?.id_number ? null : permExtractionData?.id_number.replace(" ", ""),
              IdNumber:
                permExtractionData?.id_number !== null
                  ? permExtractionData.id_number
                  : "",
            };
            // AVerifyDocumentData(
            //   (res: any) => verifyDocumentRes(res, callback),
            //   verifyDrivingObj
            // );
          }
        } else if (id.documentid === corrAadhaarDocumnetId) {
          GlobalStore.corrAadhaarOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";
          if (!GlobalStore.corrAadhaarOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of Aadhar"
            );
            setCorrespondanceAddress({ ...initialAddressObj });
          } else {
            let corrsExtractionData = res?.data?.result?.extraction_output;
            // setCorrespondanceAddress({
            //   ...correspondanceAddress,
            //   addressLine1: corrsExtractionData?.address,
            //   City: corrsExtractionData?.district,
            //   State: corrsExtractionData?.state,
            //   PinCode: corrsExtractionData.pincode,
            //   clientName: corrsExtractionData?.name_on_card,
            //   documentNumber:
            //     corrsExtractionData?.id_number?.length > 4
            //       ? `XXXX XXXX ${corrsExtractionData?.id_number?.slice(-4)}`
            //       : corrsExtractionData?.id_number
            //       ? `XXXX XXXX ${corrsExtractionData?.id_number}`
            //       : "",
            // });
            setCorrespondanceAddress((correspondanceAddress: any) => {
              correspondanceAddress.addressLine1 = corrsExtractionData?.address;
              correspondanceAddress.City = corrsExtractionData?.district;
              correspondanceAddress.State = corrsExtractionData?.state;
              correspondanceAddress.PinCode = corrsExtractionData.pincode;
              correspondanceAddress.clientName =
                corrsExtractionData?.name_on_card;
              correspondanceAddress.documentNumber =
                corrsExtractionData?.id_number?.length > 4
                  ? `XXXX XXXX ${corrsExtractionData?.id_number?.slice(-4)}`
                  : corrsExtractionData?.id_number
                    ? `XXXX XXXX ${corrsExtractionData?.id_number}`
                    : "";
              return correspondanceAddress;
            });
            if (
              corrsExtractionData.id_number === null ||
              corrsExtractionData.id_number === ""
            ) {
              alert("please Upload front side of Adhaar as well");
            } else {
              if (callback !== undefined) callback(true);
            }
            // setAadharNo(corrsExtractionData?.id_number);
            //if (res?.data?.result?.qr_detected) {

            if (
              res?.data?.result?.qr_detected &&
              res?.data?.result?.qr_encoded &&
              res?.data?.result?.qr_scannable
            ) {
              setAutQcFlagCor(true);
            } else {
              setAutQcFlagCor(false);
            }

            if (res?.data?.result?.qr_detected) {
              setQrVerifiedCorrsAadhar(true);
              setErrCode("");
            } else {
              setQrVerifiedCorrsAadhar(false);
              setErrCode("Please upload a valid Document");
            }
          }
        } else if (id.documentid === corrPassportDocumnetId) {
          GlobalStore.corrPassportOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";
          if (!GlobalStore.corrPassportOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of Aadhar"
            );
            setCorrespondanceAddress({ ...initialAddressObj });
          } else {
            let corrsExtractionData = res?.data?.result?.extraction_output;
            // setCorrespondanceAddress({
            //   ...correspondanceAddress,
            //   addressLine1: corrsExtractionData?.address,
            //   City: corrsExtractionData?.district,
            //   State: corrsExtractionData?.state,
            //   PinCode: corrsExtractionData.pincode,
            //   clientName: corrsExtractionData?.name_on_card,
            //   documentNumber: corrsExtractionData?.id_number,
            //   dateOfIssue: corrsExtractionData?.date_of_issue,
            //   dateOfExpiry: corrsExtractionData?.date_of_expiry,
            // });
            setCorrespondanceAddress((correspondanceAddress: any) => {
              correspondanceAddress.addressLine1 = corrsExtractionData?.address;
              correspondanceAddress.City = corrsExtractionData?.district;
              correspondanceAddress.State = corrsExtractionData?.state;
              correspondanceAddress.PinCode = corrsExtractionData.pincode;
              correspondanceAddress.clientName =
                corrsExtractionData?.name_on_card;
              correspondanceAddress.documentNumber =
                corrsExtractionData?.id_number;
              correspondanceAddress.dateOfIssue =
                corrsExtractionData?.date_of_issue;
              correspondanceAddress.dateOfExpiry =
                corrsExtractionData?.date_of_expiry;

              return correspondanceAddress;
            });
          }

          if (callback !== undefined) callback(true);
        } else if (id.documentid === corrVoterIdDocumentId) {
          GlobalStore.corrVoterIdOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";
          if (!GlobalStore.corrVoterIdOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of Aadhar"
            );
            setCorrespondanceAddress({ ...initialAddressObj });
          } else {
            let corrsExtractionData = res?.data?.result?.extraction_output;
            // setCorrespondanceAddress({
            //   ...correspondanceAddress,
            //   addressLine1: corrsExtractionData?.address,
            //   City: corrsExtractionData?.district,
            //   State: corrsExtractionData?.state,
            //   PinCode: corrsExtractionData.pincode,
            //   clientName: corrsExtractionData?.name_on_card,
            //   documentNumber: corrsExtractionData?.id_number,
            // });
            setCorrespondanceAddress((correspondanceAddress: any) => {
              correspondanceAddress.addressLine1 = corrsExtractionData?.address;
              correspondanceAddress.City = corrsExtractionData?.district;
              correspondanceAddress.State = corrsExtractionData?.state;
              correspondanceAddress.PinCode = corrsExtractionData.pincode;
              correspondanceAddress.clientName =
                corrsExtractionData?.name_on_card;
              correspondanceAddress.documentNumber =
                corrsExtractionData?.id_number;
              // correspondanceAddress.dateOfIssue=corrsExtractionData?.date_of_issue;
              // correspondanceAddress.dateOfExpiry=corrsExtractionData?.date_of_expiry;

              return correspondanceAddress;
            });
            if (callback !== undefined) callback(true);
          }
        } else if (id.documentid === corrDlDocumentId) {
          GlobalStore.corrDlOCRObj =
            res.data.result !== null ? res.data.result.extraction_output : "";
          if (!GlobalStore.corrDlOCRObj.address) {
            alert(
              //"Address is not present in the uploaded file, upload back side of the Aadhar as well."
              "Address is not available, please ensure that you upload the 2nd Side of Aadhar"
            );
            setCorrespondanceAddress({ ...initialAddressObj });
          } else {
            let corrsExtractionData = res?.data?.result?.extraction_output;
            // setCorrespondanceAddress({
            //   ...correspondanceAddress,
            //   addressLine1: corrsExtractionData?.address,
            //   City: corrsExtractionData?.district,
            //   State: corrsExtractionData?.state,
            //   PinCode: corrsExtractionData.pincode,
            //   documentNumber: corrsExtractionData?.id_number,
            //   clientName: corrsExtractionData?.name_on_card,
            //   dateOfIssue:
            //     moment(
            //       moment(corrsExtractionData?.issue_dates, "DD/MM/YYYY")
            //     ).format("YYYY/MM/DD") == "Invalid date"
            //       ? undefined
            //       : moment(
            //           moment(corrsExtractionData?.issue_dates, "DD/MM/YYYY")
            //         ).format("DD/MM/YYYY"),

            //   dateOfExpiry:
            //     moment(
            //       moment(corrsExtractionData?.date_of_validity, "DD/MM/YYYY")
            //     ).format("YYYY/MM/DD") == "Invalid date"
            //       ? undefined
            //       : moment(
            //           moment(corrsExtractionData?.date_of_validity, "DD/MM/YYYY")
            //         ).format("DD/MM/YYYY"),
            // });
            setCorrDLExtractData(corrsExtractionData);
            setCorrespondanceAddress((correspondanceAddress: any) => {
              correspondanceAddress.addressLine1 = corrsExtractionData?.address;
              correspondanceAddress.City = corrsExtractionData?.district;
              correspondanceAddress.State = corrsExtractionData?.state;
              correspondanceAddress.PinCode = corrsExtractionData.pincode;
              correspondanceAddress.clientName =
                corrsExtractionData?.name_on_card;
              correspondanceAddress.documentNumber =
                corrsExtractionData?.id_number;
              correspondanceAddress.dateOfIssue =
                moment(
                  moment(corrsExtractionData?.issue_dates, "DD/MM/YYYY")
                ).format("YYYY/MM/DD") == "Invalid date"
                  ? undefined
                  : moment(
                    moment(corrsExtractionData?.issue_dates, "DD/MM/YYYY")
                  ).format("DD/MM/YYYY");
              correspondanceAddress.dateOfExpiry =
                moment(
                  moment(corrsExtractionData?.date_of_validity, "DD/MM/YYYY")
                ).format("YYYY/MM/DD") == "Invalid date"
                  ? undefined
                  : moment(
                    moment(
                      corrsExtractionData?.date_of_validity,
                      "DD/MM/YYYY"
                    )
                  ).format("DD/MM/YYYY");

              return correspondanceAddress;
            });
            if (callback !== undefined) callback(true);

            let verifyDrivingObj = {
              ActionName: "verify_with_source",
              ApplicationId: GlobalStore.applicationID,
              DateOfBirth: corrsExtractionData?.date_of_birth,
              DocumentType: "ind_driving_license",
              Source: "DIY",
              // IdNumber: corrsExtractionData?.id_number ? null : corrsExtractionData?.id_number.replace(" ", ""),
              IdNumber:
                corrsExtractionData?.id_number !== null
                  ? corrsExtractionData.id_number
                  : "",
            };
            // AVerifyDocumentData(
            //   (res: any) => corrsVerifyDocumentRes(res, callback),
            //   verifyDrivingObj
            // );
          }
        }
      }
    } else {
      // gtmService({ action: "ExtractDocumentData", label: "ERROR || ERR134-S" });
    }
  };
  const corrsVerifyDocumentRes = (res: any, callback?: Function) => {
    if (!res || res.error) {
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data && res?.data.verified) {
        setErrCode("");
        SetCorrsDrivingFlag(true);
        if (callback !== undefined) {
          callback(true);
        }
      } else {
        setErrCode(res?.data?.Message);
        SetCorrsDrivingFlag(false);
      }
      setIsLoading(false);
    }
  };
  const verifyDocumentRes = (res: any, callback?: Function) => {
    if (!res || res.error) {
      setErrCode(res.error);
      setIsLoading(false);
    } else {
      if (res.data && res?.data.verified) {
        setErrCode("");
        setDrivingFlag(true);
        if (callback !== undefined) {
          setIsLoading(true);
          callback(true);
        }
      } else {
        setErrCode(res?.data?.Message);
        setDrivingFlag(false);
        setIsLoading(false);
      }
      // setIsLoading(false);
    }
  };
  const getPDFData = (res: any) => {
    if (!res || res.error) {
      setErrCode(res.error);
      // gtmService({
      //   action: "MargeMultipleImagestoPDF",
      //   label: "ERROR || ERR136",
      // });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        setAddressName(res.data.Guid);
        permAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: permAddressObj.documentcategory,
          documentid: permAddressObj.documentId,
          source: DIY,
        };
        if (permAddressObj.documentId === aadhaarDocumnetId) {
          setIsLoading(true);
          AextractAadhaar(
            (res: any) => storeOcrData(res, addressOCR),
            addressOCR,
            "OCR"
          );
        } else if (permAddressObj.documentId === passportDocumnetId) {
          setIsLoading(true);
          AextractPassport(
            (res: any) => storeOcrData(res, addressOCR),
            addressOCR
          );
        } else if (permAddressObj.documentId === voterIdDocumentId) {
          setIsLoading(true);
          AextractVoterid(
            (res: any) => storeOcrData(res, addressOCR),
            addressOCR
          );
        } else if (permAddressObj.documentId === dlDocumentId) {
          setIsLoading(true);
          AextractDl((res: any) => {
            storeOcrData(res, addressOCR);
          }, addressOCR);
        }
      } else {
        // gtmService({
        //   action: "MargeMultipleImagestoPDF",
        //   label: "ERROR || ERR136-S",
        // });
      }
    }
  };
  const getCorrPDFData = (res: any) => {
    if (!res || res.error) {
      gtmService({
        action: "MargeMultipleImagestoPDF",
        label: "ERROR || ERR137",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        setIsLoading(false);
        setCorrAddressName(res.data.Guid);
        corrAddressObj.mimeType = "application/pdf";
        const addressOCR = {
          applicationid: GlobalStore.applicationID,
          base64document: res.data.Mergedimagespdfbase64,
          documentcategory: corrAddressObj.documentcategory,
          documentid: corrAddressObj.documentId,
          source: DIY,
        };
        if (corrAddressObj.documentId === corrAadhaarDocumnetId) {
          setIsLoading(true);
          AextractAadhaar(
            (res: any) => storeOcrData(res, addressOCR),
            addressOCR,
            "OCR"
          );
        } else if (corrAddressObj.documentId === corrPassportDocumnetId) {
          setIsLoading(true);
          AextractPassport(
            (res: any) => storeOcrData(res, addressOCR),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrVoterIdDocumentId) {
          setIsLoading(true);
          AextractVoterid(
            (res: any) => storeOcrData(res, addressOCR),
            addressOCR
          );
        } else if (corrAddressObj.documentId === corrDlDocumentId) {
          setIsLoading(true);
          AextractDl((res: any) => {
            storeOcrData(res, addressOCR);
          }, addressOCR);
        }
      } else {
        // gtmService({
        //   action: "MargeMultipleImagestoPDF",
        //   label: "ERROR || ERR137-S",
        // });
      }
    }
  };
  const onUploadProgress = (
    event: ProgressEvent,
    id: string,
    fileName: string,
    type: string
  ) => {
    const { loaded, total } = event;
    let percentage = Math.floor((loaded * 100) / total);
    let permAddressCopy = { ...permAddressObj };
    let permSecondAddressCopy = { ...permSecondAddressObj };
    let corrAddressCopy = { ...corrAddressObj };
    let corrSecondAddressCopy = { ...corrSecondAddressObj };
    console.log(fileName, "fileName check 2");
    if (percentage < 100) {
      if (id === "permAddress") {
        permAddressCopy.id = id;
        permAddressCopy.disable = false;
        permAddressCopy.uploadPer = percentage;
        permAddressCopy.hideProgress = true;
        permAddressCopy.showFile = false;
        setPermAddressObj(permAddressCopy);
      } else if (id === "permSecondAddress") {
        permSecondAddressCopy.id = id;
        permSecondAddressCopy.disable = false;
        permSecondAddressCopy.uploadPer = percentage;
        permSecondAddressCopy.hideProgress = true;
        permSecondAddressCopy.showFile = false;
        setPermSecondAddressObj(permSecondAddressCopy);
      } else if (id === "corrAddress") {
        corrAddressCopy.id = id;
        corrAddressCopy.disable = false;
        corrAddressCopy.uploadPer = percentage;
        corrAddressCopy.hideProgress = true;
        corrAddressCopy.showFile = false;
        setCorrAddressObj(corrAddressCopy);
      } else if (id === "corrSecondAddress") {
        corrSecondAddressCopy.id = id;
        corrSecondAddressCopy.disable = false;
        corrSecondAddressCopy.uploadPer = percentage;
        corrSecondAddressCopy.hideProgress = true;
        corrSecondAddressCopy.showFile = false;
        setCorrSecondAddressObj(corrSecondAddressCopy);
      }
    } else if (percentage === 100) {
      if (id === "permAddress") {
        permAddressCopy.id = id;
        permAddressCopy.disable = false;
        permAddressCopy.uploadPer = percentage;
        permAddressCopy.showFile = false;
        permAddressCopy.hideProgress = false;
        permAddressCopy.mimeType = type;
        permAddressCopy.fileName = fileName;
        setPermAddressObj(permAddressCopy);
      } else if (id === "permSecondAddress") {
        permSecondAddressCopy.id = id;
        permSecondAddressCopy.disable = false;
        permSecondAddressCopy.uploadPer = percentage;
        permSecondAddressCopy.showFile = false;
        permSecondAddressCopy.hideProgress = false;
        permSecondAddressCopy.mimeType = type;
        permSecondAddressCopy.fileName = fileName;
        setPermSecondAddressObj(permSecondAddressCopy);
      } else if (id === "corrAddress") {
        corrAddressCopy.id = id;
        corrAddressCopy.disable = false;
        corrAddressCopy.uploadPer = percentage;
        corrAddressCopy.showFile = false;
        corrAddressCopy.hideProgress = false;
        corrAddressCopy.mimeType = type;
        corrAddressCopy.fileName = fileName;
        setCorrAddressObj(corrAddressCopy);
      } else if (id === "corrSecondAddress") {
        corrSecondAddressCopy.id = id;
        corrSecondAddressCopy.disable = false;
        corrSecondAddressCopy.uploadPer = percentage;
        corrSecondAddressCopy.showFile = false;
        corrSecondAddressCopy.hideProgress = false;
        corrSecondAddressCopy.mimeType = type;
        corrSecondAddressCopy.fileName = fileName;
        setCorrSecondAddressObj(corrSecondAddressCopy);
      }
    }
  };
  function handleSameAsAbove(event: React.ChangeEvent<HTMLInputElement>) {
    if (event.target.name === "sameAscorrespondance") {
      sameAsPermanent && setCorrespondanceAddress({ ...initialAddressObj });
      !sameAsPermanent && setCorrespondanceAddress({ ...permanentAddress });
      if (!sameAsPermanent) {
        setCorrErrorObj({});
      }
      setSameAsPermanent(!sameAsPermanent);
      setCorrAddressObj({
        ...initialDocObj,
        documentcategory: corrAddressObj?.documentcategory,
        documentCategoryId: corrAddressObj?.documentCategoryId,
      });
      setCorrSecondAddressObj({ ...initialPanDocObj });
      setErrors({ ...errors, correspondanceAddress: "" });
      setDefaultCorrAddress("");
      setQrVerifiedCorrsAadhar(false);
      SetCorrsDrivingFlag(false);
    }
  }
  const removeSpclCracters = (value: string) => {
    if (value) {
      return value; //.replace(/[^a-zA-Z0-9 ]/g, " ");
    } else {
      return "";
    }
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    let progressCalled = false;

    const processUpload = async (
      payload: any,
      extractData: any,
      addressObj: any,
      dlDocumentId: any,
      uploadInfo: any,
      verifyResFn: Function,
      isFirstUpload: boolean
    ) => {
      if (!payload?.uploadObj || !payload?.saveObj) return;

      await AUploadDocument(
        (res: any) => {
          getUploadResNew(
            res,
            payload.id,
            payload.uploadObj.base64document,
            payload.uploadObj.filename,
            payload.callbackFunction
          );

          const isDLMatched =
            addressObj?.documentId === dlDocumentId &&
            extractData?.date_of_birth;

          if (isDLMatched) {
            const verifyDrivingObj = {
              ActionName: "verify_with_source",
              ApplicationId: GlobalStore.applicationID,
              DateOfBirth: extractData.date_of_birth,
              DocumentType: "ind_driving_license",
              Source: "DIY",
              IdNumber: uploadPayload?.saveObj?.documentInfo[0]?.documentNumber || dlDocumentId || "",
            };

            AVerifyDocumentData(
              (res: any) =>
                verifyDocumentRes(res, () => {
                  console.log("logger 1", res);
                  if (isFirstUpload && !progressCalled) {
                    progressCalled = true
                    saveAddressDetails();
                  }
                }),
              verifyDrivingObj
            );
          } else {
            if (isFirstUpload && !progressCalled) {
              progressCalled = true
              saveAddressDetails();
            }
          }
        },
        payload.uploadObj,
        (event: ProgressEvent) => {
          onUploadProgress(event, payload.id, payload.fileName, payload.type);
        },
        payload.saveObj
      );
    };

    // Then correspondence (no progress handler)
    if (uploadPayloadCorr) {
      await processUpload(
        uploadPayloadCorr,
        corrDLExtractData,
        corrAddressObj,
        corrDlDocumentId,
        corrDlUploadInformation,
        corrsVerifyDocumentRes,
        true // progress not called again
      );
    }

    // Call permanent first (with progress)
    await processUpload(
      uploadPayload,
      dlExtractData,
      permAddressObj,
      dlDocumentId,
      dlUploadInformation,
      verifyDocumentRes,
      true // progress should be called here
    );

  };


  const saveAddressDetails = () => {
    console.log("logger 2")
    const correspondanceAddressLine = repairAddressWithConditions(
      correspondanceAddress.addressLine1,
      correspondanceAddress.City
    );
    const permanentAddressLine = repairAddressWithConditions(
      permanentAddress.addressLine1,
      permanentAddress.City
    );
    let userId = "0";
    console.log("searchByPan token", decryptJwtToken(GlobalStore?.token));
    const tokenObj: string = decryptJwtToken(GlobalStore?.token);
    if (tokenObj !== "" && !!tokenObj && tokenObj?.length > 0) {
      let tokenMainObj: ITokenObj = JSON.parse(tokenObj) as ITokenObj;
      userId = tokenMainObj?.UserId?.toString();
    }
    let saveAddressPayload = {
      ApplicationId: GlobalStore.applicationID,
      corrsaddraspermanent: sameAsPermanent,
      createdBy: parseInt(userId),
      CorrespondenceAddressDetails: {
        CorrespondenceAddressLine1:
          removeSpclCracters(correspondanceAddressLine.addLine1) || "",
        CorrespondenceAddressLine2:
          removeSpclCracters(correspondanceAddressLine.addLine2) || "",
        CorrespondenceAddressLine3:
          removeSpclCracters(correspondanceAddressLine.addLine3) || "",
        CorrespondenceAddressLine4:
          removeSpclCracters(correspondanceAddressLine.addLine4) || "",
        CorrespondencePincode: correspondanceAddress.PinCode,
        CorrespondenceCountry: correspondanceAddress.Country,
        CorrespondenceState: correspondanceAddress.State,
        CorrespondenceCity: correspondanceAddress.City,
        CorrespondenceDistrict: correspondanceAddress.District,
        CorrespondenceArea: correspondanceAddress.Area,
        CorrespondenceStatecode: Number(correspondanceAddress.StateCode),
        CorrespondenceCountryCode: Number(correspondanceAddress.CountryCode),
        CorrespondenceAddressType: addressType,
        autoQC: true,
        documentIssueDate: correspondanceAddress?.dateOfIssue
          ? correspondanceAddress?.dateOfIssue?.split("/").reverse()?.join("-")
          : null,

        documentExpiryDate: correspondanceAddress?.dateOfExpiry
          ? correspondanceAddress?.dateOfExpiry?.split("/").reverse()?.join("-")
          : null,

        documentName: correspondanceAddress.clientName
          ? correspondanceAddress.clientName
          : "",
        documentNumber:
          defaultCorrAddress === "Aadhaar Card"
            ? correspondanceAddress.documentNumber.slice(-4)
            : correspondanceAddress.documentNumber,
        DocumentId: corrAddressObj.documentId
          ? Number(corrAddressObj.documentId)
          : sameAsPermanent
            ? Number(permAddressObj.documentId)
            : "",
      },
      PermanentAddressDetails: {
        PermanentAddressLine1:
          removeSpclCracters(permanentAddressLine.addLine1) || "",
        PermanentAddressLine2:
          removeSpclCracters(permanentAddressLine.addLine2) || "",
        PermanentAddressLine3:
          removeSpclCracters(permanentAddressLine.addLine3) || "",
        PermanentAddressLine4:
          removeSpclCracters(permanentAddressLine.addLine4) || "",
        PermanentPincode: permanentAddress.PinCode,
        PermanentCountry: permanentAddress.Country,
        PermanentState: permanentAddress.State,
        PermanentCity: permanentAddress.City,
        PermanentDistrict: permanentAddress.District,
        Permanentarea: permanentAddress.Area,
        Permanentstatecode: Number(permanentAddress.StateCode),
        Permanentcountrycode: Number(permanentAddress.CountryCode),
        PermanentAddresstype: addressType,
        autoQC: true,
        documentIssueDate: permanentAddress?.dateOfIssue
          ? permanentAddress?.dateOfIssue?.split("/").reverse()?.join("-")
          : null,
        documentExpiryDate: permanentAddress?.dateOfExpiry
          ? permanentAddress?.dateOfExpiry?.split("/").reverse()?.join("-")
          : null,
        documentName: permanentAddress.clientName
          ? permanentAddress.clientName
          : "",
        documentNumber:
          defaultAddress === "Aadhaar Card"
            ? permanentAddress.documentNumber.slice(-4)
            : permanentAddress.documentNumber,
        DocumentId: permAddressObj.documentId
          ? Number(permAddressObj.documentId)
          : "",
      },
    };
    console.log("permAddressObj", saveAddressPayload);

    ASaveAddressDetails((res: any) => saveAddressRes(res), saveAddressPayload);
  };
  const saveDocument = () => {
    setIsLoading(true);
    const saveDetails = [];
    console.log(
      "PO=",
      permAddressObj,
      "==||==",
      permanentAddress,
      " ||  CO=",
      corrAddressObj,
      "==||==",
      correspondanceAddress
    );
    if (
      (permAddressObj.uploadPer === 100 && isNewPermAddress) ||
      permAddressObj.isWatsappFlag
    ) {
      let savepermAddressObj = {
        documentCategoryId: permAddressObj.documentCategoryId?.toString(),
        documentId: permAddressObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: addressName || permAddressObj.fileName,
        isfilecropped: true,
        mimeType: permAddressObj.mimeType,
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: permAddressObj.isWatsappFlag,
        personaldetailsid: "0",
        //autoqc: qrVerifiedAadhar ? qrVerifiedAadhar : false,
        autoqc: autoQCFlagPer,
        DocumentIssueDate: permanentAddress?.dateOfIssue
          ? permanentAddress?.dateOfIssue?.split("/")?.reverse()?.join("-")
          : null,
        DocumentName: permanentAddress?.clientName,
        documentNumber:
          defaultAddress === "Aadhaar Card"
            ? permanentAddress.documentNumber.slice(-4)
            : permanentAddress.documentNumber,
        IsDocumentVerified: drivingFlag ? drivingFlag : false,
        IsQRVerified: qrVerifiedAadhar ? qrVerifiedAadhar : false,
      };
      saveDetails.push(savepermAddressObj);
    }
    if (
      (corrAddressObj.uploadPer === 100 && isNewCorrAddress) ||
      corrAddressObj.isWatsappFlag
    ) {
      let saveCorrAddressObj = {
        documentCategoryId: corrAddressObj.documentCategoryId?.toString(),
        documentId: corrAddressObj.documentId?.toString(),
        documentexpirydate: "",
        fileName: corrAddressName || corrAddressObj.fileName,
        isfilecropped: true,
        mimeType: corrAddressObj.mimeType,
        panno: GlobalStore.personaldetails.pan,
        isWatsappFlag: corrAddressObj.isWatsappFlag,
        personaldetailsid: "0",
        // autoqc: qrVerifiedCorrsAadhar ? qrVerifiedCorrsAadhar : false,
        autoqc: autoQCFlagCor,
        DocumentIssueDate: correspondanceAddress?.dateOfIssue
          ? correspondanceAddress?.dateOfIssue?.split("/")?.reverse()?.join("-")
          : null,
        DocumentName: correspondanceAddress?.clientName,
        documentNumber:
          defaultAddress === "Aadhaar Card"
            ? correspondanceAddress.documentNumber.slice(-4)
            : correspondanceAddress.documentNumber,
        IsDocumentVerified: corrsDrivingFlag ? corrsDrivingFlag : false,
        IsQRVerified: qrVerifiedCorrsAadhar ? qrVerifiedCorrsAadhar : false,
      };
      saveDetails.push(saveCorrAddressObj);
    }

    const objUTM_Info = utmDurationInfoObj(startTime, "documentsdur");
    const saveObj = {
      applicationId: GlobalStore.applicationID,
      clientPrimaryDetailId: GlobalStore.clientPrimaryDetailId || 0,
      documentInfo: saveDetails,
      leadId: GlobalStore.leadId,
      objUTM_Info: objUTM_Info,
    };
    ASavePersonalDocument(getSaveStatus, saveObj);
  };

  const getSaveStatus = (res: any) => {
    if (!res || res.error) {
      //setErrCode(1641)
      setErrCode(res.error);
      gtmService({
        action: "SaveUploadedDocumentDetails",
        label: "ERROR || ERR133",
      });
      setIsLoading(false);
    } else {
      if (res.data) {
        // Clevertap event: submit documents data
        const data = {
          EventName:
            cleverTapEvents.registration.documentVerificationPage
              .CLICK_ON_SUBMIT,
          InitiationPlatform: "",
          UTM_SOURCE: props.UTM_SOURCE || "",
          UTM_MEDIUM: props.UTM_MEDIUM || "",
          UTM_CAMPAIGN: props.UTM_CAMPAIGN || "",
          KRA: GlobalStore.isKRA,
          ADHAR_LINKED_WITH_MOBILE: "",
          DIGILOCKER_PROCESS: GlobalStore.isDigiLocker,
          ADDRESS_PROOF_SUBMITTED_VIA: "upload_now",
          LEAD_ID: GlobalStore.leadId,
          REF_ID: GlobalStore.applicationID,
        };

        ClevertapService.pushEvent(data);
        // Clevertap ends here

        // Apps flyer event for click on proceed on plan details page
        AppsFlyerService.pushEvent(
          appsFlyerEvents.registration.documentVerificationPage.CLICK_ON_SUBMIT
        );
        // AGetPendingDocument(pendingDocQC, GlobalStore.applicationID);
      } else {
        setIsLoading(false);
        gtmService({
          action: "SaveUploadedDocumentDetails",
          label: "ERROR || ERR133-S",
        });
      }
    }
  };

  const saveAddressRes = (res: any) => {
    if (!res || res.error) {
      // setErrCode("164- Failed to get the document status for the application.");
      setErrCode(res.error);
    } else {
      if (res?.data && res?.data?.result) {
        // saveDocument();
        completeModuleStatus(dashboardUrl.personalIfo);
        // gtmService({ action: "PROFILE_DETAILS", label: "Step_Complete" });
        // history.push(incompleteStageNavigation());
        navigate(incompleteStageNavigation())

        const clientPartialDetails_ao = JSON.parse(
          localStorageGetItem("clientPartialDetails_ao") || "{}"
        );
        GlobalStore.personaldetails.pincode = permanentAddress.PinCode;
        GlobalStore.isManual = true;
        clientPartialDetails_ao.PinCode = permanentAddress.PinCode;
        clientPartialDetails_ao.isManual = true;
        clientPartialDetails_ao.sameAsPermanent = sameAsPermanent;
        clientPartialDetails_ao.addressLine1 = permanentAddress.addressLine1;
        if (!sameAsPermanent) {
          clientPartialDetails_ao.corrAddress =
            correspondanceAddress.addressLine1;
          clientPartialDetails_ao.corrPincode = correspondanceAddress.PinCode;
        }
        localStorageSetItem(
          "clientPartialDetails_ao",
          JSON.stringify(clientPartialDetails_ao)
        );
        sessionStorage.removeItem("appendedStage");
      } else {
        setErrCode(res?.data?.message);
      }
    }
    setIsLoading(false);
  };
  const setSampleRender = () => {
    setRenderSamplePopup(true);
  };
  console.log("addrerss", permanentAddress, correspondanceAddress);
  console.log(
    "ciond",
    defaultAddress === "Driving License" && drivingFlag == false,
    defaultCorrAddress === "Driving License" && corrsDrivingFlag == false,
    permanentAddress,
    correspondanceAddress,
    "conidiotn",
    Object.values(permanentAddress).some((value) => !value) ||
    Object.values(correspondanceAddress).some((value) => !value) ||
    Object.values(permErrorObj).some((error) => error) ||
    Object.values(corrErrorObj).some((error) => error) ||
    Object.values(errors).some((error) => error) ||
    (defaultAddress === "Driving License" && drivingFlag == false) ||
    (defaultCorrAddress === "Driving License" && corrsDrivingFlag == false) ||
    (defaultAddress === "Aadhaar Card" && !qrVerifiedAadhar) ||
    (defaultCorrAddress === "Aadhaar Card" && !qrVerifiedCorrsAadhar),
    defaultCorrAddress === "Aadhaar Card" && !qrVerifiedCorrsAadhar
  );

  function getClientStageDetails(res: any) {
    if (!res || res.error) {
    } else if (res.data) {
      const responseObj = JSON.parse(res.data);
      if (responseObj?.iskra) {
        window.location.reload();
      }
    }
  }

  useEffect(() => {
    AGetStageCompletionStatus(
      (res: any) => getClientStageDetails(res),
      GlobalStore.applicationID
    );
  }, [])

  return (
    <div className="bnklHome">
      <h1 className="bnklHeading">Personal Documents</h1>
      <div className="bnkSubHeading">
        Provide your personal details and address to recieve important letters
        and emails.
      </div>
      <EdModal
        isOpen={showInfoModal}
        title=""
        message={
          <>
            For New Mutual Fund Transaction, you should be KRA Validated. The same can be done only by uploading Aadhar. In case, you don't provide Aadhar you may have limited access to Mutual Funds or No Access.
          </>
        }
        onClose={() => setShowInfoModal(false)}
      />
      {/* {showInfoModal && (
        <InfoModal
          width={DeviceContext().isMobile ? "328px" : "354px"}
        >
          <div className="explainInfo">
            <label>
              A Politically Exposed Person (PEP) is a person who
              can potentially be influenced by political parties
              directly or indirectly.
            </label>
          </div>
          <div>
            <Button
              btnName="OK"
              onClick={() => {
                setShowInfoModal(false)
              }}
            >
              OK
            </Button>
          </div>
        </InfoModal>
      )} */}
      <div className={"formLayout " + (isLoading ? " op05" : "")}>
        <div className="mgt40">
          {/* Permanent Address Proof */}
          <label className="bankDoc" htmlFor="identificationDetailPerm"> Permanent Address Proof</label>
          <DropdownSearch
            id="identificationDetailPerm"
            name="identificationDetailPerm"
            defaultValue={
              identificationListPerm.find(
                (item) => item.display === defaultAddress
              )?.display
            }
            onOptionSelect={(val) => {
              handlePermanentAddress(val)
              val.display !== "Aadhaar Card" && setShowInfoModal(true)
              console.log("eeeeeeeeeeeeeeeeeeeeeeeeeeeeeee", val.display !== "Aadhaar Card");

            }}
            searchLength={0}
            options={identificationListPerm}
            onBlur={(val) => handleAddressBlur(val, "permanentAddress")}
            errorText={errors.permanentAddress}
            searchKey="display"
            placeholder="Select Personal Address Proof"
            isDownArrow={true}
          />
          <p className="help_text blue mrt10">
            Upload clear scanned image of both front and back of the card or
            upload them in a single PDF.
          </p>
          {regectedDocStatus &&
            regectedDocStatus.map(function (item: any) {
              return (
                <div className="mrt20 mrt10">
                  {" "}
                  {item.ContentType === "PROOF OF ADDRESS PERMANENT" && (
                    <ErrMsg>
                      <>
                        <span>
                          Reason for Rejection: {item.RejectionReason}
                        </span>
                      </>
                    </ErrMsg>
                  )}
                </div>
              );
            })}
          <br />

          {defaultAddress && (
            <>
              <button
                type="button"
                className="view-sample"
                onClick={() => {
                  try {
                    const screen_name = getScreenName(window.location.pathname);
                    if (screen_name) {
                      mixpanelService({
                        event: mixpanelEvents.CTA_CLICKED,
                        screen_name,
                        text: "View Sample",
                        cta_type: "sticky",
                        cta_class: "secondary",
                        cta_service: "AOJ",
                      });
                    }
                  } catch (e) {
                    console.error("mixpanel cta_clicked failed", e);
                  }
                  console.log("rrrr");
                  setSampleRender();
                }}
              >
                View Sample
              </button>
              {renderSamplePopups && (
                <>
                  {DeviceContext().isMobile ? (
                    <>
                      {getUISampleMobilePopups(
                        identificationListPerm.find(
                          (item) => item.display === defaultAddress
                        )?.value
                      )}
                    </>
                  ) : (
                    <>
                      {getUISamplePopups(
                        identificationListPerm.find(
                          (item) => item.display === defaultAddress
                        )?.value
                      )}
                    </>
                  )}
                </>
              )}
              <div>
                <div className="mrt20">
                  <DocumentBrowse
                    id="permAddress"
                    previewImageexternalClassName={"maxSizewithAnother"}
                    docObj={permAddressObj}
                    onDocUploadComplete={onPermanentAddressUploadDocument}
                    isRemove={onFirstPermAddressRemove}
                  />
                  {permAddListError != "" ? (
                    <div>
                      {" "}
                      <br />
                      <ErrMsg>
                        <>
                          <span>{permAddListError}</span>
                        </>
                      </ErrMsg>
                    </div>
                  ) : (
                    ""
                  )}
                </div>
                {anotherFile && (
                  <div className="row">
                    <div className="mrt20">
                      <DocumentBrowse
                        id="permSecondAddress"
                        docObj={permSecondAddressObj}
                        previewImageexternalClassName={"maxSizewithAnother"}
                        onDocUploadComplete={
                          onPermanantSecondAddressUploadDocument
                        }
                        isRemove={onSecondPermAddressRemove}
                      />
                      {permSecAddListError != "" ? (
                        <div>
                          <br />
                          <ErrMsg>
                            <>
                              <span>{permSecAddListError}</span>
                            </>
                          </ErrMsg>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                )}
                <div className="mrt20">
                  <button type="button"
                    className={secondDoc ? "addDoc" : "addDocDisable"}
                    onClick={() => {
                      try {
                        const screen_name = getScreenName(window.location.pathname);
                        if (screen_name) {
                          mixpanelService({
                            event: mixpanelEvents.CTA_CLICKED,
                            screen_name,
                            text: "Add Document",
                            cta_type: "sticky",
                            cta_class: "primary",
                            cta_service: "AOJ",
                          });
                        }
                      } catch (e) {
                        console.error("mixpanel cta_clicked failed", e);
                      }
                      addDocument();
                    }}
                  >
                    <span className="edel-icon-plus" aria-hidden="true"></span> Add Document
                  </button>
                </div>
              </div>
            </>
          )}
        </div>
        <form className="PersonalInfoForm">
          <fieldset disabled={isLoading}>
            <legend className="sr-only">Personal information</legend>
            <>
              {((permanentAddress.addressLine1 !== null &&
                permanentAddress.addressLine1 !== undefined &&
                permanentAddress.addressLine1 !== "") ||
                (permanentAddress.PinCode !== null &&
                  permanentAddress.PinCode !== undefined &&
                  permanentAddress.PinCode !== "") ||
                (permanentAddress.City !== null &&
                  permanentAddress.City !== undefined &&
                  permanentAddress.City !== "") ||
                (permanentAddress.State !== null &&
                  permanentAddress.State !== undefined &&
                  permanentAddress.State !== "")) && (
                  <>
                    <AddressInfoField
                      defaultAddress={defaultAddress}
                      addressObj={permanentAddress}
                      addressErrorObj={permErrorObj}
                      onAddressInfoChange={(obj: any) => {
                        console.log("objjjj", obj);

                        // Update primary upload payload
                        setUploadPayload((prev: any) => {
                          if (!prev || !prev.saveObj || !prev.saveObj.documentInfo) return prev;

                          return {
                            ...prev,
                            saveObj: {
                              ...prev.saveObj,
                              documentInfo: prev.saveObj.documentInfo.map((doc: any, index: any) =>
                                index === 0 ? { ...doc, documentNumber: obj.documentNumber } : doc
                              ),
                            },
                          };
                        });
                        setPermanentAddress(obj);
                      }}
                      onAddressInfoBlur={setPermErrorObj}
                      qrVerified={
                        // false
                        defaultAddress === "Aadhaar Card" ? qrVerifiedAadhar : false
                      }
                    />
                    <AddressField
                      addressObj={permanentAddress}
                      isDisable={
                        false
                        // defaultAddress === "Aadhaar Card" ? qrVerifiedAadhar : false
                      }
                      sectionLabel="Permanent Addr."
                      addressType="correspondance"
                      setErrCode={setErrCode}
                      onAddressChange={(obj: IAddressFormat) => {
                        setPermanentAddress(obj);
                        sameAsPermanent && setCorrespondanceAddress(obj);
                      }}
                      onAddressBlur={setPermErrorObj}
                      handleSameAsAbove={() => { }}
                    />
                  </>
                )}
              {!sameAsPermanent && (
                <>
                  <div className="mrt40">
                    <label className="fieldLbl" htmlFor="identificationDetailCorrs">
                      Correspondance Address Proof
                    </label>
                    <span className="sectionLbl">
                      <span className="fieldLblRight">Same as above</span>
                      <div className="crrAddCheckBox fieldLblRight">
                        <Checkbox
                          checked={sameAsPermanent || false}
                          name={`sameAscorrespondance`}
                          onChange={handleSameAsAbove}
                        />
                      </div>
                    </span>
                  </div>
                  <div className="mgt60 row">
                    <DropdownSearch
                      id="identificationDetailCorrs"
                      name="identificationDetailCorrs"
                      defaultValue={
                        identificationListCorr.find(
                          (item) => item.display === defaultCorrAddress
                        )?.display
                      }
                      onOptionSelect={(val) => handleCorrespondenceAddress(val)}
                      searchLength={0}
                      options={identificationListCorr}
                      onBlur={(val) =>
                        handleAddressBlur(val, "correspondanceAddress")
                      }
                      errorText={errors.correspondanceAddress}
                      searchKey="display"
                      placeholder="Select Personal Address Proof"
                      isDownArrow={true}
                    />
                    {regectedDocStatus &&
                      regectedDocStatus.map(function (item: any) {
                        return (
                          <div className="mrt20 mrt10">
                            {" "}
                            {item.ContentType ===
                              "PROOF OF ADDRESS CORRESPONDENCE" && (
                                <ErrMsg>
                                  <>
                                    <span>
                                      Reason for Rejection: {item.RejectionReason}
                                    </span>
                                  </>
                                </ErrMsg>
                              )}
                          </div>
                        );
                      })}
                    <div>
                      <p className="help_text blue mrt10">
                        Upload clear scanned image of both front and back of the
                        card or upload them in a single PDF.
                      </p>

                      {defaultCorrAddress && (
                        <>
                          <br />
                          <button type="button"
                            className="view-sample"
                            onClick={() => {
                              try {
                                const screen_name = getScreenName(window.location.pathname);
                                if (screen_name) {
                                  mixpanelService({
                                    event: mixpanelEvents.CTA_CLICKED,
                                    screen_name,
                                    text: "View Sample",
                                    cta_type: "sticky",
                                    cta_class: "secondary",
                                    cta_service: "AOJ",
                                  });
                                }
                              } catch (e) {
                                console.error("mixpanel cta_clicked failed", e);
                              }
                              setRenderCorrSamplePopup(true);
                            }}
                          >
                            View Sample
                          </button>
                          {renderCorrSamplePopups && (
                            <>
                              {DeviceContext().isMobile ? (
                                <>
                                  {getUISampleCorrMobilePopups(
                                    identificationListCorr.find(
                                      (item) =>
                                        item.display === defaultCorrAddress
                                    )?.value
                                  )}
                                </>
                              ) : (
                                <>
                                  {getUICorrSamplePopups(
                                    identificationListCorr.find(
                                      (item) =>
                                        item.display === defaultCorrAddress
                                    )?.value
                                  )}
                                </>
                              )}
                            </>
                          )}
                          <div className="mrt20">
                            <DocumentBrowse
                              id="corrAddress"
                              docObj={corrAddressObj}
                              previewImageexternalClassName={
                                "maxSizewithAnother"
                              }
                              onDocUploadComplete={
                                onCorrespondanceAddressUploadDocument
                              }
                              isRemove={onFirstCorrAddressRemove}
                            />
                            {corrAddListError != "" ? (
                              <div>
                                {" "}
                                <br />
                                <ErrMsg>
                                  <>
                                    <span>{corrAddListError}</span>
                                  </>
                                </ErrMsg>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          {corrAnotherFile && (
                            <div className="row">
                              <div className="mrt20">
                                <DocumentBrowse
                                  id="corrSecondAddress"
                                  previewImageexternalClassName={
                                    "maxSizewithAnother"
                                  }
                                  docObj={corrSecondAddressObj}
                                  onDocUploadComplete={
                                    onCorrespondanceSecondAddressUploadDocument
                                  }
                                  isRemove={onSecondCorrAddressRemove}
                                />
                                {corrAddListError != "" ? (
                                  <div>
                                    {" "}
                                    <br />
                                    <ErrMsg>
                                      <>
                                        <span>{corrAddListError}</span>
                                      </>
                                    </ErrMsg>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          )}
                          <div className="mrt20">
                            <button type="button"
                              className={
                                corrSecondDoc ? "addDoc" : "addDocDisable"
                              }
                              onClick={() => {
                                try {
                                  const screen_name = getScreenName(window.location.pathname);
                                  if (screen_name) {
                                    mixpanelService({
                                      event: mixpanelEvents.CTA_CLICKED,
                                      screen_name,
                                      text: "Add Document",
                                      cta_type: "sticky",
                                      cta_class: "primary",
                                      cta_service: "AOJ",
                                    });
                                  }
                                } catch (e) {
                                  console.error("mixpanel cta_clicked failed", e);
                                }
                                addCorrDocument();
                              }}
                            >
                              <span className="edel-icon-plus" aria-hidden="true"></span> Add
                              Document
                            </button>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              )}

              {(sameAsPermanent ||
                (correspondanceAddress.addressLine1 !== null &&
                  correspondanceAddress.addressLine1 !== undefined &&
                  correspondanceAddress.addressLine1 !== "" &&
                  correspondanceAddress.addressLine1 !== "0") ||
                (correspondanceAddress.PinCode !== null &&
                  correspondanceAddress.PinCode !== undefined &&
                  correspondanceAddress.PinCode !== "") ||
                (correspondanceAddress.City !== null &&
                  correspondanceAddress.City !== undefined &&
                  correspondanceAddress.City !== "") ||
                (correspondanceAddress.State !== null &&
                  correspondanceAddress.State !== undefined &&
                  correspondanceAddress.State !== "")) && (
                  <>
                    <AddressInfoField
                      defaultAddress={defaultCorrAddress}
                      addressObj={correspondanceAddress}
                      addressErrorObj={corrErrorObj}
                      onAddressInfoChange={(obj: any) => {
                        setCorrespondanceAddress(obj);
                        debugger
                        setUploadPayloadCorr((prev: any) => {
                          if (!prev || !prev.saveObj || !prev.saveObj.documentInfo) return prev;

                          return {
                            ...prev,
                            saveObj: {
                              ...prev.saveObj,
                              documentInfo: prev.saveObj.documentInfo.map((doc: any, index: any) =>
                                index === 0 ? { ...doc, documentNumber: obj.documentNumber } : doc
                              ),
                            },
                          };
                        });
                      }}
                      onAddressInfoBlur={setCorrErrorObj}
                      qrVerified={
                        // false
                        defaultAddress === "Aadhaar Card" ? qrVerifiedAadhar : false
                      }
                    />
                    <AddressField
                      addressObj={correspondanceAddress}
                      isDisable={
                        false
                        // defaultAddress === "Aadhaar Card" ? qrVerifiedAadhar : false
                      }
                      sectionLabel="Correspondence Addr."
                      addressType="correspondance"
                      setErrCode={setErrCode}
                      onAddressChange={setCorrespondanceAddress}
                      onAddressBlur={setCorrErrorObj}
                      showSameAsAbove
                      sameAsAbove={sameAsPermanent}
                      handleSameAsAbove={handleSameAsAbove}
                    />
                    <div className="termList mrt41">
                      <Checkbox
                        checked={true}
                        name="termone"
                        onChange={() => { }}
                      />
                      <span className="mrl13 crrAddCheckBoxleft sectionLbl">
                        Confirm if the address mentioned is similar to above
                      </span>
                    </div>
                  </>
                )}
            </>

            {errCode && (
              <div className="errMsgBlck errWidth mrt40">
                <ErrMsg>
                  {typeof errCode === "number" ? (
                    <>
                      <span>We are facing some technical issue.</span>
                      <span>
                        Please try after sometime (error code:{errCode})
                      </span>
                    </>
                  ) : (
                    <span>{errCode}</span>
                  )}
                </ErrMsg>
              </div>
            )}
            {/* {aadharNo && localAadharNo && localAadharNo != aadharNo && (
              <div className="errMsgBlck errWidth mrt40">
                <ErrMsg>
                  <>
                    <label>
                      Document is not valid Please upload Valid Document
                    </label>
                  </>
                </ErrMsg>
              </div>
            )} */}

            <div className="docSubBtn">
              <SubmitButton
                isLoading={isLoading}
                btnName="Save Address Details"
                onClick={handleSubmit}
                disabled={
                  Object.values(permanentAddress).some((value) => !value) ||
                  Object.values(correspondanceAddress).some(
                    (value) => !value
                  ) ||
                  Object.values(permErrorObj).some((error) => error) ||
                  Object.values(corrErrorObj).some((error) => error) ||
                  Object.values(errors).some((error) => error) ||
                  // (defaultAddress === "Driving License" &&
                  //   drivingFlag == false) ||
                  (defaultCorrAddress === "Driving License" &&
                    corrsDrivingFlag == false) ||
                  (defaultAddress === "Aadhaar Card" && !qrVerifiedAadhar) ||
                  (defaultCorrAddress === "Aadhaar Card" &&
                    !qrVerifiedCorrsAadhar) ||
                  shouldDisable()
                  // ((defaultAddress === "Aadhaar Card" ||
                  //   defaultCorrAddress === "Aadhaar Card") &&
                  //   aadharNo &&
                  //   localAadharNo &&
                  //   localAadharNo != aadharNo)
                }
              />
            </div>
          </fieldset>
        </form>
      </div>
    </div>
  );
};

export default PersoanlInfo;